/* eslint import/prefer-default-export: 0 */

export const foreign = {
  pvq: {
    intro: {
      title: 'Foreign associations',
      body:
        'You will be asked questions about your current and previous foreign associations and be asked to provide details if necessary.',
    },
    tour: {
      para: 'Take a guided tour through the section',
    },
    review: {
      para: 'View all the sections associated with foreign associations at once',
    },
    section: {
      name: 'Foreign associations',
    },
    subsection: {
      intro: 'Introduction',
      passport: 'U.S. passport information',
      contacts: 'Section 25: Foreign contacts',
      activities: {
        label: 'Foreign activities',
        direct: 'Direct control',
        indirect: 'Indirect control',
        realestate: 'Real estate purchase',
        benefits: 'Foreign benefits',
        support: 'Foreign national support',
        futurebenefit: 'Future foreign Interest',
        currentbenefit: 'Current foreign Benefit',
        ongoingsupport: 'Foreign benefit eligible'

      },
      business: {
        intro: 'Introduction',
        label: 'Foreign business, professional activities, and government contacts',
        advice: 'Support provided',
        family: 'Immediate family foreign support',
        employment: 'Employment',
        ventures: 'Other business ventures',
        conferences: 'Event participation',
        contact: 'Immediate family contact',
        sponsorship: 'Foreign national sponsorship',
        political: 'Held political office',
        voting: 'Voting',
      },
      travel: 'Section 22 - Foreign Travel',
      review: 'Review',
    },
    destination: {
      intro: 'Foreign intro',
      review: 'Review Foreign Associations',
      history: 'Your History',
      tbd: 'TBD',
      contacts: 'Foreign contacts',
      passport: 'U.S. passport information',
      activity: 'Foreign activities',
      'activities/intro': 'Introduction',
      'activities/direct': 'Direct control',
      'activities/indirect': 'Indirect control',
      'activities/realestate': 'Real estate purchase',
      'activities/benefits': 'Foreign benefits',
      'activities/future': 'Future benefits',
      'activities/current': 'Current foreign benefit',
      'activities/support': 'Foreign national support',
      'business/advice': 'Support provided',
      'business/family': 'Immediate family foreign support',
      'business/employment': 'Employment',
      'business/ventures': 'Other business ventures',
      'business/conferences': 'Event participation',
      'business/contact': 'Immediate family contact',
      'business/sponsorship': 'Foreign national sponsorship',
      'business/political': 'Held political office',
      'business/voting': 'Voting',
      travel: 'Foreign countries you have visited',
    },
    passport: {
      title: 'U.S. passport information',
      info: {
        text:
          'Provide the following information for the most recent U.S. passport you currently possess.',
        link: 'U.S. State Department passport help',
      },
      question: {
        title: 'Do you possess a U.S. passport (current or expired)?',
        yes: 'Yes',
        no: 'No',
      },
      label: {
        bookNumber: 'Passport number',
        book: 'Passport',
      },
      name: 'Provide the name in which passport was first issued',
      number: 'Provide your U.S. passport number',
      issued: 'Provide the issue date of the passport',
      expiration: 'Provide the expiration date of the passport',
      help: {
        number: {
          title: 'Passport',
          message:
            'U.S. Passport numbers must be nine alphanumeric characters (letters and numbers).',
          note: '',
        },
        issued: {
          title: 'Use the exact date',
          message: 'Enter the date on your passport.',
          note: '',
        },
        expiration: {
          title: 'Use the exact date',
          message: 'Enter the date on your passport.',
          note: '',
        },
      },
      branch: {
        help: {
          title: 'Need more information about the U.S. passport?',
          message: 'Select whether you possess a U.S. passport',
          note: '',
        },
      },
    },
    activities: {
      intro: {
        intro0: 'Section 26 - Foreign Financial Interests and Foreign Benefits',
        intro1: 'This section asks for information regarding any foreign financial interests or benefits you or your family members have or had in the past five years. Information requested includes what the foreign financial interests or benefits are, their value, and who controls them, as applicable.',
        intro2: 'For this section:',
        intro3: 'Foreign means non-U.S. -- that is, any geographic location not within the 50 U.S. states, the District of Columbia, and the U.S. territories.',
        intro4: 'A person has a foreign financial interest in a foreign account if the person is the owner or co-owner of record or has legal title. This applies whether the account is maintained for the persons own benefit or for the benefit of others. Examples of foreign financial interests include foreign (non-U.S.) stocks, bonds, property, investments, bank accounts, ownership of corporate entities, corporate interests or exchange traded funds (ETFs) held in specific geographical or economic sectors. Foreign financial interests do not include financial interests in companies or diversified mutual funds or diversified ETFs that are publicly traded on a U.S. exchange.',
        intro5: 'A dependent child is an unmarried child, stepchild, legally adopted child or foster child, or child of a domestic partner who is: 1) younger than 19 years old, 2) at least 19 but less than age 24 years old and who regularly attends an accredited school or college, or 3) permanently and totally disabled -- and, in all 3 cases is primarily dependent on you for support and maintenance.',
        intro6: 'For purposes of this form a committed, spouse-like relationship is defined as a relationship between two people who are not in a legally-recognized marriage, union, or domestic partnership, present themselves as a couple, and live together continuously.',

      },

      direct: {
        heading: {
          title: 'Have you, your spouse or legally recognized civil union/domestic partner, cohabitant, or dependent children EVER had any foreign financial interests in which you or they have direct control or direct ownership?',
          title5: 'Future Foreign Interest',
          relationshipNature: 'What is or was your relationship to this co-owner?',
          name: 'What is the name of the co-owner?',
          countries: 'Provide country(ies) of citizenship for this co-owner. (Select all that apply.)',
          isUs: 'Does this co-owner currently live in the U.S.?',
          coAddress: 'What is their address?',
          notUs: 'Where do they live?',
          additional: 'Do you have another co-owner for this foreign financial interest to report?',
          cotitle: 'Are there or were there any co-owners for this foreign financial interest?',

        },
        para: {
          intro: [
            'Foreign financial interest examples:  stocks, property, investments, bank accounts, ownership of corporate entities, corporate interests or exchange traded funds (ETFs) held in specific geographical or economic sectors.',
            'Exclude financial interests in companies or diversified mutual funds or diversified ETFs that are publicly traded on a U.S. exchange.',
          ],
          howAcquired: 'Such as purchase, gift, etc.',
        },
        collection: {
          summary: 'Provide your direct financial interests here',
          description: 'Summary of financial interests',
          appendTitle:
            'Do you, your spouse or legally recognized civil union/domestic partner, cohabitant, or dependent children have any additional foreign financial interests?',
          appendLabel: 'Add another direct interest',
          itemType: 'Interest',
        },
        help: {
          directControl: {
            title: '"Direct control" defined:',
            message:
              'Direct control means there are *no* intermediary or intervening factors between the foreign financial interest and the owner/controller.',
            note:
              'Example: You own a bakery in a foreign country and you directly control all aspects of the business such as pricing, baking, etc.',
          },
        },
        appendMessage: [
          'Do you have another instance in which you or any of the people listed below owned a foreign financial interest in the last five years?',
          '- Spouse or legally-recognized partner from a civil marriage, civil union, domestic partnership, or common law marriage.',
          '- Person with whom you are in a committed, spouse-like relationship',
          '- Dependent child',

        ],
        interest: {
          para: {
            checkAll: 'Check all that apply',
            howAcquired: 'Such as purchase, gift, etc.',
          },
          heading: {
            interestTypes: 'Specify',
            interestType: 'Provide the type of financial interest',
            acquired: 'Provide the date acquired',
            howAcquired: 'Provide how the financial interest was acquired',
            cost: 'Provide the cost (in U.S. dollars) at time of acquisition',
            value:
              'Provide the current value (in U.S. dollars) or the value at the time control or ownership was sold, lost or otherwise disposed of',
            relinquished: 'Provide the date control or ownership was relinquished',
            explanation:
              'Provide explanation of how interest control or ownership was sold, lost or otherwise disposed of',
          },
          label: {
            relinquishedNotApplicable: 'Not applicable',
            or: 'or',
            costEstimated: 'Estimated',
            valueEstimated: 'Estimated',
            interestTypes: {
              yourself: 'Yourself',
              spouse: 'Spouse or legally recognized civil union/domestic partner',
              cohabitant: 'Cohabitant',
              dependentChildren: 'Dependent children',
            },
          },
          report: 'Do you have another co-owner for this foreign financial interest to report?',
          primary: {
            who: 'Who is or was the co-owner?',
            type: 'Who owns or owned a foreign financial interest in the past five years? (If more than one person owns or owned the financial interest select one. You will be given the opportunity to add co-owners.)',
          },

          help: {
            interestTypes: {
              title: 'Need help with the interest type field?',
              message: 'Check all that apply',
              note: '',
            },
            interestType: {
              title: 'Specify everyone who had a foreign financial interests?',
              message: 'Select all people involved with this specific foreign financial interests.',
              note: '',
            },
            acquired: {
              title: 'Estimate the date if unsure',
              message:
                'If you are not sure of the exact date give us your best guess and check the "Estimated" checkbox.',
              note: '',
            },
            howAcquired: {
              title: 'Need help with how the interest was acquired?',
              message: 'Provide how the financial interest was acquired',
              note: '',
            },
            cost: {
              title: 'Need help with the cost?',
              message: 'If you are not sure of the exact amount give us your best guess.',
              note: '',
            },
            value: {
              title: 'Need help with the value?',
              message: 'If you are not sure of the exact amount give us your best guess.',
              note: '',
            },
            relinquished: {
              title:
                'When you were no longer in control or an owner of this foreign financial interest',
              message:
                'If you are not sure of the exact date give us your best guess and check the "Estimated" checkbox.',
              note: '',
            },
            explanation: {
              title: 'Need help with this explanation?',
              message:
                'Tell us how you got rid of your ownership or control of this financial interest.',
              note: '',
            },
          },
          coOwner: {

            heading: {
              name: 'Provide full name of co-owner',
              address: "Provide co-owner's current address",
              countries: 'Provide co-owner’s country(ies) of citizenship',
              relationshipNature: 'Provide the nature of your relationship with the co-owner',
            },
            label: {
              address: 'This address is',
              none: 'None',
            },
            help: {
              countries: {
                title: "Need help with co-owner's country(ies) of citizenship?",
                message:
                  'Tell us all of the citizenships this person has.  Selected values will appear below the country selection.',
                note: 'Note: You can provide multiple citizenships in this question.',
              },
              relationshipNature: {
                title: 'Need help with the nature of the relationship?',
                message: 'Provide the nature of your relationship with the co-owner',
                note: '',
              },
            },
          },
          coOwners: {
            name: 'What is the name of the dependent child?',
            heading: {
              hasCoOwners: 'Are there any co-owners of this foreign financial interest?',
              hasCoOwnersAppend:
                'Are there any additional co-owners of this foreign financial interest?',
            },
          },
        },
      },
      futureFinancialInterests: {
        label: {
          question: 'Do you or any of the people listed below expect to own any foreign financial interests in the future?',
          peopleList: [
            'Spouse or legally recognized partner from a civil marriage, civil union, domestic partnership, or common law marriage',
            'Person with whom you are in a committed, spouse-like relationship',
            'Dependent child'
          ],
          expectedOwner: 'Who expects to own a foreign financial interest in the future?',
          dependentChildName: 'What is the name of the dependent child?',
          lastName: 'Last Name',
          firstName: 'First Name',
          middleName: 'Middle Name',
          suffix: 'Suffix',
          financialInterestType: 'What is the foreign financial interest?',
          explanationOther: 'Please explain.',
          countryAssociation: 'What country is this financial interest associated with?',
          expectedReceiptDate: 'When do you or the person you listed above expect to receive this future foreign financial interest?',
          expectedReason: 'Why do you or the person you listed above expect to receive this future foreign financial interest?',
          additionalInstances: 'Do you have another instance in which you or any of the people listed below expect to own a foreign financial interest in the future?'
        },
        collection: {
          description: 'Summary of expected future foreign financial interests',
          appendTitle: 'Do you have any other expected future foreign financial interests to report?',
          appendLabel: 'Add another expected foreign financial interest',
          itemType: 'Future Foreign Financial Interest'
        },
        footer: {
          anotherInstance: 'Do you have another instance in which you or one of the people listed below is eligible to receive benefits from a foreign country in the future?',
          spouse: 'Spouse or legally recognized partner from a civil marriage, civil union, domestic partnership, or common law marriage',
          person: 'Person with whom you are in a committed, spouse-like relationship',
          child: 'Dependent child',

        },
      },
      usCitizenQuestion: {
        label: {
          question: 'This question is for U.S. citizens only. If you are not a U.S. citizen go to Section 27.',
          title1: 'A foreign national is any person who is not a citizen or national of the U.S.',
          title2: 'Financial support is any amount of monetary assistance. (This does not include one-time minor purchases (such as toiletries, a magazine, a paperback book or other small item purchases), buying a lunch or dinner, or the like.)',
        }
      },
      financialSupportInquiry: {
        label: {
          question: 'Have you provided financial support to a foreign national in the past five years?',

        },
        individualName: {
          description: 'What is the foreign national\'s name?',

        },
        residenceInUS: {
          label: {
            question: 'Does this foreign national currently live in the U.S.?',

          }
        },

        relationshipToForeignNational: {
          description: 'What is your relationship to this foreign national?',

        },
        frequencyOfSupport: {
          description: 'How often do you or did you give money to this foreign national?',

        },
        totalAmountGiven: {
          description: 'What is the total amount of money you\'ve given this foreign national (in U.S. dollars)?',

        },
        reasonForSupport: {
          description: 'Why do you or did you give money to this foreign national?',

        },
        futureSupportPlan: {
          label: {
            question: 'Do',
          }
        },
      },
      financialInterest: {
        itemfooter: 'Do you have another instance in which you or any of the people listed below owned a foreign financial interest in the last five years?',
        controlled: 'Is there or was there another company, organization, or person (other than the owner or co-owner) that controlled this foreign financial interest on behalf of the owner or co-owner? (Select the applicable box.)',
        explanation: 'Please explain.',
        label: 'Who owns or owned a foreign financial interest in the past five years? If more than one person owns or owned the financial interest select one. You will be given the opportunity to add co-owners.',
        dependentChild: 'What is the name of the dependent child?',
        explain: 'Please explain.',
        question: 'What is the foreign financial interest you or the person(s) you listed above own or owned? (Check one. There will be an opportunity to input multiple entries.)',
        realEstate: {
          type: 'What type of real estate is this?',
          location: {
            label: 'Where is this real estate located?',
            street: 'Street (include Apt #, Unit #, or Suite #, if applicable)',

          },
          acquisition: {
            acquisitionDate: 'When was this real estate acquired?',
            acquisitionHow: 'How was this real estate acquired?',
            cost: 'How much did you or the person(s) you listed above pay for this real estate (in U.S. dollars)?',
            currentOwnership: 'Do you or the person(s) you named above own this real estate today?',
            value: 'What is the current value of this real estate (in U.S. dollars)?',
            relinquishedValue: 'What was the value of this real estate when it was sold or otherwise relinquished?',
            relinquishedDate: 'When was this real estate sold or otherwise relinquished?'
          }
        },
        association: {
          country: 'Which foreign country is or was this foreign financial interest associated with?',
          acquisitionDate: 'When was this foreign financial interest acquired?',
          explain: 'Please explain.',
          label: 'How was this foreign financial interest acquired?',
          cost: 'How much did you or the person(s) you listed above pay for this foreign financial interest (in U.S. dollars)?',
          currentOwnership: 'Do you or the person(s) you named above own this financial interest today?',

          currentValue: 'What is the current value of this foreign financial interest (in U.S. dollars)?',
          relinquishedValue: 'What was the value of this foreign financial interest when it was sold, lost, or otherwise relinquished (in U.S. dollars)?',
          relinquishedMethod: {
            label: 'How was this financial interest relinquished?',
            org: 'Does or did a company, organization, or person (other than the owner or co-owner) control this foreign financial interest on behalf of the owner or co-owner? (Select the applicable box.)',
            relinquishedDate: 'When was this foreign financial interest relinquished?'

          },
          orgRelationship: 'What is the relationship of the person who controls this foreign financial interest to the owner or co-owner of this financial interest?',
          orgName: 'What is the name of the person who controls the foreign financial interest?',
          companyName: 'What is the name of the company or organization that controlled this foreign financial interest on behalf of the owner or co-owner?',
          orgCountry: 'What country is associated with the financial interest.',
          unknownStreet: 'Please provide physical address (not mailing address)',
          unknownLabel: 'Does this person currently live in the U.S.?',
          orgQuestion: 'Is there or was there another company, organization, or person (other than the owner or co-owner) that controlled this foreign financial interest on behalf of the owner or co-owner?',
          citizenship: 'Provide country(ies) of citizenship for this person. (Select all that apply.)',
        },
      },
      benefits: {
        label: {
          educationalMedicalRetirementBenefits: 'Have you or any of the people listed below received any educational, medical, retirement, social welfare, or other such benefits from a foreign country in the past five years?',
          peopleList: [
            'Spouse or legally recognized partner from a civil marriage, civil union, domestic partnership, or common law marriage',
            'Person with whom you are in a committed, spouse-like relationship',
            'Dependent child'
          ],
          receiver: 'Who received this benefit? (If more than one of the people listed received a benefit select one. There will be an opportunity to input multiple entries.)',
          dependentChildName: 'What is the name of the dependent child?',
          benefitType: 'What type of benefit was received? (If more than one, select one. There will be an opportunity to input multiple entries.)',
          explain: 'Please explain',
          benefitNature: 'Was this a one-time benefit or is it a continuing or recurring benefit?',
          benefitReceivedDate: 'When did you or the person you listed above receive this benefit?',
          benefitValue: 'What is the total value of the benefit you or the person you listed above received (in U.S. dollars)?',
          benefitReason: 'Why did you or the person you listed above receive this benefit?',
          firstBenefitReceivedDate: 'When did you or the person you listed above first receive this benefit?',
          benefitEndDate: 'When is this benefit expected to end?',
          oneTime: 'One Time',
          recurring: 'Recurring',
          benefitFrequency: 'How often is this benefit received?',
          totalBenefitsValue: 'What is the total value of the benefit you or the person you listed above have received to date (in U.S. dollars)?',
          receivingReason: 'Why are you or the person you listed above receiving this benefit?',
          futurePlans: 'Do you or the person you listed above plan on accepting this benefit in the future?',
          benefitCountry: 'What country provides or provided this benefit?',
          obligation: 'Does this benefit obligate you or the person you listed above in any way to this foreign country?',
          additionalInstances: 'Do you have another instance in which you or one of the people listed below received benefits from a foreign country in the past five years?',
          DollarValue: 'What is the dollar value of this foreign benefit?',
        },
        collection: {
          description: 'Summary of benefits received from foreign countries',
          appendTitle: 'Do you have any other instances to report?',
          appendLabel: 'Add another instance of benefits received',
          itemType: 'Benefit Instance'
        }
      },

      indirect: {
        heading: {
          title:
            'Have you, your spouse or legally recognized civil union/domestic partner, cohabitant, or dependent children EVER had any foreign financial interests that someone controlled on your behalf?',
          title1: 'Do you control (not own) a foreign financial interest on someone elses behalf?',
        },
        footer: 'Do you have another instance in which you control (not own) a foreign financial interest on someone elses behalf?',
        collection: {
          summary: 'Provide your indirect financial interests here',
          description: 'Summary of financial interests',
          appendTitle:
            'Do you, your spouse or legally recognized civil union/domestic partner, cohabitant, or dependent children have any additional foreign financial interests controlled on your behalf?',
          appendLabel: 'Add another indirect interest',
          itemType: 'Interest',
          who: 'Who do you control a foreign financial interest for?',
          what: 'What is the foreign financial interest? ',

        },
        help: {
          indirectControl: {
            title: '"Indirect control" defined:',
            message:
              'Indirect control means there *are* intermediary or intervening factors between the foreign financial interest and the owner/controller.',
            note:
              'Example: You own a bakery in a foreign country and have an employee directly control aspects of the business such as pricing, baking, etc.',
          },
        },
        interest: {
          para: {
            checkAll: 'Check all that apply',
            howAcquired: 'Such as purchase, gift, etc.',
          },
          heading: {
            interestTypes: 'Specify',
            interestType: 'Provide the type of financial interest',
            name:
              'Provide the name of the individual who controls this financial interest on your behalf',
            relationship: 'Provide this individual’s relationship to you',
            acquired: 'Provide the date the financial interest was acquired',
            howAcquired: 'Provide details regarding how it was acquired',
            cost: 'Provide the cost (in U.S. dollars) at time of acquisition',
            value:
              'Provide the current value (in U.S. dollars) or the value at the time control or ownership was sold, lost or otherwise disposed of',
            sold: 'Provide the date interest was sold, lost, or otherwise disposed of',
            explanation: 'Provide explanation if interest was sold, lost, or otherwise disposed of',
            valueother: 'What is the value of this foreign financial interest?',
            country: 'What country is this foreign financial interest associated with?',
            whyControl: 'Why do you control this foreign financial interest for this person?',
            footer: 'Do you have another instance in which you control (not own) a foreign financial interest on someone else\'s behalf?',

          },
          label: {
            firstname: 'First name',
            lastname: 'Last name',
            soldNotApplicable: 'Not applicable',
            or: 'or',
            costEstimated: 'Estimated',
            valueEstimated: 'Estimated',
            interestTypes: {
              yourself: 'Yourself',
              spouse: 'Spouse or legally recognized civil union/domestic partner',
              cohabitant: 'Cohabitant',
              dependentChildren: 'Dependent children',
            },
          },
          help: {
            interestTypes: {
              title: 'Specify everyone who had a foreign financial interests',
              message: 'Select all people involved with this specific foreign financial interest.',
              note: '',
            },
            interestType: {
              title: 'Need help with the indirect interest type?',
              message: 'Provide the type of financial interest',
              note: '',
            },
            name: {
              title: 'Need help with the name of the person?',
              message:
                'Provide the name of the individual who controls this financial interest on your behalf',
              note: '',
            },
            acquired: {
              title: 'Estimate the date if unsure',
              message:
                'If you are not sure of the exact date give us your best guess and check the "Estimated" checkbox.',
              note: '',
            },
            howAcquired: {
              title: 'Need help with how the interest was acquired?',
              message: 'Provide how the financial interest was acquired',
              note: '',
            },
            cost: {
              title: 'Need help with the cost?',
              message:
                'If you are not sure of the exact amount give us your best guess and check the "Estimated" checkbox.',
              note: '',
            },
            value: {
              title: 'Need help with the value?',
              message:
                'If you are not sure of the exact amount give us your best guess and check the "Estimated" checkbox.',
              note: '',
            },
            sold: {
              title: 'When you got rid of of this foreign financial interest',
              message:
                'If you are not sure of the exact date give us your best guess and check the "Estimated" checkbox.',
              note: '',
            },
            explanation: {
              title: 'Need help with this explanation?',
              message: 'Tell us how you got rid of of this foreign financial interest.',
              note: '',
            },
            relationship: {
              title: 'How do you know this person',
              message:
                'Let us know how you know this person and give us details of your relationship with them.',
              note: '',
            },
          },
          coOwner: {
            heading: {
              name: 'Provide full name of co-owner',
              address: 'Provide co-owner current address',
              countries: 'Provide co-owner’s country(ies) of citizenship',
              relationshipNature: 'Provide the nature of your relationship with the co-owner',
            },
            label: {
              address: 'This address is',
            },
            help: {
              countries: {
                title: "Need help with co-owner's country(ies) of citizenship?",
                message:
                  'Tell us all of the citizenships this person has.  Selected values will appear below the country selection.',
                note: 'Note: You can provide multiple citizenships in this question.',
              },
              relationshipNature: {
                title: 'Need help with the nature of this relationship?',
                message:
                  'Let us know how you know this person and give us details of your relationship with them.',
                note: '',
              },
            },
          },
          coOwners: {
            heading: {
              hasCoOwners:
                'Are there any co-owners of the foreign financial interest controlled on your behalf?',
              hasCoOwnersAppend:
                'Are there any additional co-owners for this foreign financial interest controlled on your behalf to report?',
            },
          },
        },
      },
      future: {
        heading: 'Do you or any of the people listed below expect to own any foreign financial interests in the future?',
        heading1: 'Spouse or legally recognized partner from a civil marriage, civil union, domestic partnership, or common law marriage',
        heading2: 'Person with whom you are in a committed, spouse-like relationship',
        heading3: 'Dependent child',

      },
      appendMessage: [
        'Do you have another instance in which you or any of the people listed below expect to own a foreign financial interest in the future?',
        '- Spouse or legally-recognized partner from a civil marriage, civil union, domestic partnership, or common law marriage.',
        '- Person with whom you are in a committed, spouse-like relationship',
        '- Dependent child',
      ],
      currentMessage: [
        'Do you have another instance in which you or any of the people listed below received educational, medical, retirement, social welfare, or other such benefits from a foreign country in the past five years?',
        '- Spouse or legally-recognized partner from a civil marriage, civil union, domestic partnership, or common law marriage.',
        '- Person with whom you are in a committed, spouse-like relationship',
        '- Dependent child',
      ],
      currentTitle: [
        'Have you or any of the people listed below received any educational, medical, retirement, social welfare, or other such benefits from a foreign country in the past five years?',
        '- Spouse or legally recognized partner from a civil marriage, civil union, domestic partnership, or common law marriage',
        '- Person with whom you are in a committed, spouse-like relationship',
        '- Dependent child',

      ],
      directTitle: [
        'Have you or any of the people listed below owned a foreign financial interest in the past five years?',
        '- Spouse or legally recognized partner from a civil marriage, civil union, domestic partnership, or common law marriage',
        '- Person with whom you are in a committed, spouse-like relationship',
        '- Dependent child',

      ],
      futureTitle: [
        'Do you or any of the people listed below expect to own any foreign financial interest in the future?',
        '- Spouse or legally recognized partner from a civil marriage, civil union, domestic partnership, or common law marriage',
        '- Person with whom you are in a committed, spouse-like relationship',
        '- Dependent child',
      ],
      indirectMessage: [
        'Do you or any of the people listed below expect to own any foreign financial interests in the future?',
        '-Spouse or legally recognized partner from a civil marriage, civil union, domestic partnership, or common law marriage',
        'Person with whom you are in a committed, spouse-like relationship',
        'Dependent child',
      ],
      supportTitle: [
        'For this question:',
        '- A foreign national is any person who is not a citizen or national of the U.S.',
        '- Financial support is any amount of monetary assistance. (This does not include one-time minor purchases (such as toiletries, a magazine, a paperback book or other small item purchases), buying a lunch or dinner, or the like.).',
        'Have you provided financial support to a foreign national in the past five years?'
      ],
      ongoingTitle: [
        'Are you or any of the people listed below eligible to receive benefits from a foreign country in the future?',
        ' - Spouse or legally recognized partner from a civil marriage, civil union, domestic partnership, or common law marriage',
        ' - Person with whom you are in a committed, spouse-like relationship',
        ' - Dependent child',

      ],

      collection: {

        itemType: {
          current: 'Benefit',
          ongoing: 'Ongoing',
          future: 'Future',
        },
        summary: {
          current: 'Provide your foreign benefits here',
          ongoing: 'Provide your ongoing benefits here',
          future: 'Provide your future benefits here',
        }

      },

      current: {
        heading: {
          title:
            'Current foreign benefit',
        },
      },

      eligible: {
        heading: {
          title:
            'Foreign benefit eligible',
        },
      },

      realestate: {
        heading: {
          title:
            'Have you, your spouse or legally recognized civil union/domestic partner, cohabitant, or dependent children EVER owned, or do you anticipate owning, or plan to purchase real estate in a foreign country?',
        },
        collection: {
          summary: 'Provide your real estate purchase here',
          description: 'Summary of financial purchase',
          appendTitle:
            'Do you have an additional instance of you, your spouse or legally recognized civil union/domestic partner, cohabitant, or dependent children EVER having owned, or anticipate owning, or planning to purchase real estate in a foreign country?',
          appendLabel: 'Add another real estate purchase',
          itemType: 'Purchase',
        },
        interest: {
          para: {
            checkAll: 'Check all that apply',
            howAcquired: 'Such as purchase, gift, etc.',
            realEstateType: 'Such as home, business, etc',
          },
          heading: {
            interestTypes: 'Specify',
            realEstateType: 'Provide the type of real estate property',
            address: 'Provide the location/address of property',
            acquired: 'Provide the date of purchase or to be acquired',
            howAcquired: 'Provide how the foreign real estate was or is to be acquired',
            cost: 'Provide the cost (in U.S. dollars) when sold or expected at time of acquisition',
            sold: 'Provide the date sold, if applicable',
          },
          label: {
            address: 'This address is',
            soldNotApplicable: 'Not applicable',
            or: 'or',
            costEstimated: 'Estimated',
            interestTypes: {
              yourself: 'Yourself',
              spouse: 'Spouse or legally recognized civil union/domestic partner',
              cohabitant: 'Cohabitant',
              dependentChildren: 'Dependent children',
            },
          },
          help: {
            purchaseDate: {
              title: 'There is a problem with the date',
              message: 'Date is prior to earliest date for yourself, your spouse, or a cohabitant.',
              note: '',
            },
            interestTypes: {
              title: 'Specify everyone who had a foreign financial interests',
              message: 'Select all people involved with this specific foreign financial interest.',
              note: '',
            },
            realEstateType: {
              title: 'Need help with the real estate interest type?',
              message: 'Provide the type of real estate interest',
              note: '',
            },
            acquired: {
              title: 'Estimate the date if unsure',
              message:
                'If you are not sure of the exact date give us your best guess and check the "Estimated" checkbox.',
              note: '',
            },
            howAcquired: {
              title: 'Need help with how the interest was acquired?',
              message: 'Provide how the financial interest was acquired',
              note: '',
            },
            cost: {
              title: 'Estimate the cost if unsure',
              message:
                'If you are not sure of the exact amount give us your best guess and check the "Estimated" checkbox.',
              note: '',
            },
            sold: {
              title: 'If the real estate in question was sold tell us when',
              message:
                'If you are not sure of the exact date give us your best guess and check the "Estimated" checkbox.',
              note: '',
            },
          },
          coOwner: {
            heading: {
              name: 'Provide full name of co-owner',
              address: 'Provide co-owner current address',
              countries: 'Provide co-owner’s country(ies) of citizenship',
              relationshipNature: 'Provide the nature of your relationship with the co-owner',
            },
            label: {
              address: 'This address is',
            },
            help: {
              countries: {
                title: 'List all citizenships this person has',
                message:
                  'You can provide multiple citizenships in this question.  Selected values will appear below the country selection.',
                note: '',
              },
              relationshipNature: {
                title: 'Need help with the nature of this relationship?',
                message:
                  'Let us know how you know this person and give us details of your relationship with them.',
                note: '',
              },
            },
          },
          coOwners: {
            heading: {
              hasCoOwners: 'Are/were/will there any co-owners of this foreign real estate?',
              hasCoOwnersAppend: 'Are there any additional co-owners for this foreign real estate?',
            },
          },
        },
      },
      support: {
        heading: {
          title: 'Have you EVER provided financial support for any foreign national?',
          name: 'Provide the name of the foreign national you support or have supported financially',
          address: 'Provide the address of the foreign national listed above',
          relationship:
            'Provide the nature of your relationship with the foreign national listed above',
          amount: 'Provide the amount (in U.S. dollars) of all financial support provided',
          frequency: 'Provide the frequency of your support',
          citizenship: "Provide this foreign national's country(ies) of citizenship",
        },
        titles: {
          summary: 'This question is for U.S. citizens only. If you are not a U.S. citizen go to Section 27.',

          title1: 'For this question:',
          title2: 'A foreign national is any person who is not a citizen or national of the U.S.',
          title3: 'Financial support is any amount of monetary assistance. (This does not include one-time minor purchases (such as toiletries, a magazine, a paperback book or other small item purchases), buying a lunch or dinner, or the like.)',
          Title4: 'Have you provided financial support to a foreign national in the past five years?',

        },
        branch: {
          name: 'What is the foreign nationals name?',
          isUs: 'Does this foreign national currently live in the U.S.?',
          address: 'What is their address?',
          military: 'What is the name of the U.S. military installation?',
          live: 'Where do they live?',
          diplomatic: 'What is the name of the U.S. military installation or U.S. diplomatic facility?',
          relationship: 'What is your relationship to this foreign national?',
          frequency: 'How often do you or did you give money to this foreign national?',
          total: 'What is the total amount of money youve given this foreign national (in U.S. dollars)?',
          why: 'Why do you or did you give money to this foreign national?',
          plan: 'Do you plan on giving money to this foreign national in the future?',
          explain: 'Please explain.',
          countries: 'Provide country(ies) of citizenship for this foreign national. (Select all that apply.)',
          repeat: 'Do you have another instance in which youve provided financial support to a foreign national in the past five years?',
        },

        label: {
          estimated: 'Estimated',
        },
        help: {
          branch: {
            title:
              'Need help determining if you have provided financial support to a foreign national?',
            message:
              'If you have provided any financial support to a foreign national then select "yes".',
            note: '',
          },
          address: {
            title: "Need help with the foreign national's address?",
            message: 'Provide the current address of the foreign national',
            note: '',
          },
          relationship: {
            title: 'Need help with the relation to the foreign national?',
            message: 'Provide the relationship to the foreign national',
            note: '',
          },
          amount: {
            title: 'Estimate the ammount if unsure',
            message:
              'If you are not sure of the exact amount give us your best guess and check the "Estimated" checkbox.',
            note: '',
          },
          frequency: {
            title: 'Need help with the frequency?',
            message: 'Provide the frequency of support',
            note: 'Note: Monthly, yearly, once, etc.',
          },
          citizenship: {
            title: 'List all citizenships this person has',
            message:
              'You can provide multiple citizenships in this question.  Selected values will appear below the country selection.',
            note: '',
          },
        },
        collection: {
          summary: {
            title: 'Summary of foreign financial support',
            item: 'Support',
            unknown: 'Provide details of foreign financial support below',
          },
          appendTitle: 'Have you additionally provided financial support for any foreign national?',
          append: 'Add another instance',
        },
      },
      benefit: {
        heading: {
          title:
            'As a U.S. citizen, have you, your spouse or legally recognized civil union/domestic partner, cohabitant, or dependent children received in the last seven (7) years, or are eligible to receive in the future, any educational, medical, retirement, social welfare, or other such benefit from a foreign country?',
          interestTypes: 'Specify',
          benefitType: 'Provide the type of benefit',
          benefitFrequency: 'Provide the frequency of the benefit',
          received: 'Provide the date the benefit was received',
          country: 'Provide the name of the country providing the benefit',
          value: 'Provide the total value (in U.S. dollars) of the benefit received.',
        },
        titles: {
          summary: 'Are you or any of the people listed below eligible to receive benefits from a foreign country in the future?',
          bullet1: 'Spouse or legally recognized partner from a civil marriage, civil union, domestic partnership, or common law marriage',
          bullet2: 'Person with whom you are in a committed, spouse-like relationship',
          bullet3: 'Dependent child',
          who: 'Who is eligible to receive a future benefit? (If more than one of the people listed is eligible select one. There will be an opportunity to input multiple entries.)',
          child: 'What is the name of the dependent child?',
          benefitDetails: 'What is the future benefit? (If more than one select one. There will be an opportunity to input multiple entries.)',
          explain: 'Please explain.',
          date: 'When are you or the person you listed above expected to receive this future benefit?',
          frequency: 'How often will you or the person you listed above receive this future benefit?',
          country: 'What country will provide this future benefit?',
          why: 'Why are you or the person you listed above eligible to receive this future benefit?',
          value: 'What is the total value of this future benefit (in U.S. dollars)?',
          accept: 'Do you or the person you listed above plan on accepting this benefit in the future?',
          obligate: 'Does this future benefit obligate you or the person you named in any way to this foreign country?',

        },
        footer: {
          summary: 'Do you have another instance in which you or one of the people listed below is eligible to receive benefits from a foreign country in the future?',
          bullet1: 'Spouse or legally recognized partner from a civil marriage, civil union, domestic partnership, or common law marriage',
          bullet2: 'Person with whom you are in a committed, spouse-like relationship',
          bullet3: 'Dependent child',

        },

        para: {
          checkAll: 'Check all that apply',
        },
        label: {
          otherBenefit: 'Provide explanation',
          otherBenefitType: 'Provide explanation',
          interestTypes: {
            yourself: 'Yourself',
            spouse: 'Spouse or legally recognized civil union/domestic partner',
            cohabitant: 'Cohabitant',
            dependentChildren: 'Dependent children',
          },
          benefitTypes: {
            educational: 'Educational',
            medical: 'Medical',
            retirement: 'Retirement',
            socialWelfare: 'Social Welfare',
            other: 'Other such benefit (Provide explanation)',
          },
          benefitFrequency: {
            oneTime: 'Onetime benefit',
            future: 'Future benefit',
            continuing: 'Continuing benefit',
            other: 'Other (Provide explanation)',
          },
        },
        collection: {
          summary: 'Provide your financial benefits here',
          description: 'Summary of financial benefits',
          appendTitle:
            'Do you, your spouse or legally recognized civil union/domestic partner, cohabitant, or dependent children receive any additional benefits from a foreign country?',
          appendLabel: 'Add another benefit',
          itemType: 'Benefit',
        },
        help: {
          benefit: {
            title: 'Need help with determining if you have received foreign benefits?',
            message:
              'As a U.S. citizen, have you, your spouse or legally recognized civil union/domestic partner, cohabitant, or dependent children received in the last seven (7) years, or are eligible to receive in the future, any educational, medical, retirement, social welfare, or other such benefit from a foreign country?',
            note: '',
          },
          interestType: {
            title: 'Need help with the interest type?',
            message: 'Provide the interest type',
            note: '',
          },
          benefitType: {
            title: 'Need help with the benefit type?',
            message: 'Provide the type of benefit',
            note: '',
          },
          benefitFrequency: {
            title: 'Need help with the benefit frequency?',
            message: 'Provide the frequency of the benefit',
            note: '',
          },
        },
        oneTime: {
          heading: {
            received: 'Provide the date the benefit was received',
            country: 'Provide the name of the country providing the benefit',
            value: 'Provide the total value (in U.S. dollars) of the benefit received.',
            reason: 'Provide the reason this benefit was received',
            obligated:
              'As a result of this benefit are you, your spouse or legally recognized civil union/domestic partner, your cohabitant, or dependent children obligated in any way to this foreign country?',
          },
          label: {
            obligatedExplanation: 'If yes provide explanation',
            valueEstimated: 'Estimated',
          },
          para: {
            obligated: 'If yes provide explanation',
          },
          help: {
            received: {
              title: 'Estimate the date if unsure',
              message:
                'If you are not sure of the exact date give us your best guess and check the "Estimated" checkbox.',
              note: '',
            },
            country: {
              title: 'Need help with the country?',
              message: 'Provide the name of the country providing the benefit',
              note: '',
            },
            value: {
              title: 'Need help with the value?',
              message: 'Provide the total value (in U.S. dollars) of the benefit received',
              note: '',
            },
            reason: {
              title: 'Need help with the reason?',
              message: 'Provide the reason this benefit was received',
              note: '',
            },
            obligated: {
              title: 'Need help with knowing if you are obligated?',
              message:
                'As a result of this benefit are you, your spouse or legally recognized civil union/domestic partner, your cohabitant, or dependent children obligated in any way to this foreign country',
              note: '',
            },
          },
        },
        future: {
          heading: {
            begin: 'Provide the date the benefit will begin',
            frequency: 'Provide the frequency the benefit will be received',
            country: 'Provide the name of the country providing the benefit',
            value: 'Provide the total value (in U.S. dollars) of the benefit to be received.',
            reason: 'Provide the reason this benefit will be received',
            obligated:
              'As a result of this benefit are you, your spouse or legally recognized civil union/domestic partner, your cohabitant, or dependent children obligated in any way to this foreign country?',
          },
          label: {
            obligatedExplanation: 'If yes provide explanation',
            valueEstimated: 'Estimated',
            frequency: {
              annually: 'Annually',
              quarterly: 'Quarterly',
              monthly: 'Monthly',
              weekly: 'Weekly',
              other: 'Other (Provide explanation)',
            },
          },
          para: {
            obligated: 'If yes provide explanation',
            frequencyOther: 'Provide explanation',
          },
          help: {
            begin: {
              title: 'Estimate the date if unsure',
              message:
                'If you are not sure of the exact date give us your best guess and check the "Estimated" checkbox.',
              note: '',
            },
            frequency: {
              title: 'Need help with the benefit frequency?',
              message: 'Provide the frequency the benefit will be received',
              note: '',
            },
            country: {
              title: 'Need help with the country?',
              message: 'Provide the name of the country providing the benefit',
              note: '',
            },
            value: {
              title: 'Need help with the value?',
              message: 'Provide the total value (in U.S. dollars) of the benefit to be received',
              note: '',
            },
            reason: {
              title: 'Need help with the reason?',
              message: 'Provide the reason this benefit will be received',
              note: '',
            },
            obligated: {
              title: 'Need help with knowing if you are obligated?',
              message:
                'As a result of this benefit are you, your spouse or legally recognized civil union/domestic partner, your cohabitant, or dependent children obligated in any way to this foreign country',
              note: '',
            },
          },
        },
        continuing: {
          heading: {
            began: 'Provide the date the benefit began',
            end: 'Provide the date the benefit is expected to end',
            frequency: 'Provide the frequency that this benefit is received',
            country: 'Provide the name of the country providing the benefit',
            value: 'Provide the total value (in U.S. dollars) of the benefit to be received',
            reason: 'Provide the reason this benefit will be received',
            obligated:
              'As a result of this benefit are you, your spouse or legally recognized civil union/domestic partner, your cohabitant, or dependent children obligated in any way to this foreign country?',
          },
          label: {
            obligatedExplanation: 'If yes provide explanation',
            valueEstimated: 'Estimated',
            frequency: {
              annually: 'Annually',
              quarterly: 'Quarterly',
              monthly: 'Monthly',
              weekly: 'Weekly',
              other: 'Other (Provide explanation)',
            },
          },
          para: {
            obligated: 'If yes provide explanation',
            frequencyOther: 'Provide explanation',
          },
          help: {
            began: {
              title: 'Estimate the date if unsure',
              message:
                'If you are not sure of the exact date give us your best guess and check the "Estimated" checkbox.',
              note: '',
            },
            end: {
              title: 'Estimate the date if unsure',
              message:
                'If you are not sure of the exact date give us your best guess and check the "Estimated" checkbox.',
              note: '',
            },
            frequency: {
              title: 'Need help with the benefit frequency?',
              message: 'Provide the frequency the benefit will be received',
              note: '',
            },
            country: {
              title: 'Need help with the country?',
              message: 'Provide the name of the country providing the benefit',
              note: '',
            },
            value: {
              title: 'Need help with the value?',
              message: 'Provide the total value (in U.S. dollars) of the benefit to be received',
              note: '',
            },
            reason: {
              title: 'Need help with the reason?',
              message: 'Provide the reason this benefit will be received',
              note: '',
            },
            obligated: {
              title: 'Need help with knowing if you are obligated?',
              message:
                'As a result of this benefit are you, your spouse or legally recognized civil union/domestic partner, your cohabitant, or dependent children obligated in any way to this foreign country',
              note: '',
            },
          },
        },
      },
    },
    contacts: {
      heading: {
        title:
          'Have you had contact with a foreign national in the past five years with whom you:',
        titleItem1: 'Had feelings of affection, or',
        titleItem2: 'Had a romantic relationship, or',
        titleItem3: 'Were bound by social, moral, financial, or legal obligations, or',
        titleItem4: 'Shared information about yourself that, if known, could be used to influence you to act against the interests of the U.S. government.',
        titleNote: '(Answer "Yes" if one or more of the bulleted answers apply.)',
        name: 'What is the foreign national\'s name?',
        firstcontact: 'When was your first contact with this foreign national?',
        lastcontact: 'When was your last contact with this foreign national?',
        methods: 'What methods do you and this foreign national use to contact one another? (Select all that apply.)',
        frequency: 'How often are you in contact with this foreign national?',
        relationship: 'What is your relationship with this person?',
        aliases: 'Has this foreign national ever used another name (for example, aliases, nicknames, or a maiden name)?',
        aliases2: 'Is there another name this foreign national uses or used (for example, aliases, nicknames, or a maiden name)?',
        aliasname: 'What other name have they used?',
        nameDescription: 'Which of the following best describes this name?',
        citizenship: 'Provide country(ies) of citizenship for this foreign national (Select all that apply.)',
        birthdate: 'What is their date of birth?',
        birthplace: 'Where were they born?',
        idkBirthplace: 'Provide explanation regarding unknown birthplace',
        employer:
          'Who does this foreign national work for? (If they are unemployed, provide the name of their most recent employer.)',
        neverWorked: 'Never Worked',
        occupation: 'If known, what is this foreign national\'s occupation?',
        employerAddress:
          'Is this employer located in the U.S.?',
        employerAddressDomesticTitle:
          "What is the employer's address?",
        employerAddressForeignTitle:
          'Where is the employer located?',
        foreignDisciplines: 'Is this person associated with any of the following foreign disciplines? (Select all that apply)',
        hasaffiliations:
          'Is this foreign national affiliated with a foreign government, military, security, defense industry, or intelligence service?',
        affiliations:
          "Describe the contact's relationship with the foreign government, military, security, defense industry, or intelligence service",
        explanation: 'Please explain.',
        howCitizenshipAcquired: 'How did this person become a citizen of this (these) foreign country(ies)? (For example, they applied for it or they acquired it through their parents or grandparents.)',
        address: 'Does this foreign national currently live in the U.S.?',
        addressDomesticTitle: 'What is their address?',
        addressForeignTitle: 'Where do they live?',
        email: 'What is the foreign national’s email address?',
        telephone: 'What is the foreign national’s phone number?',
        foreignAssociationDescription: 'Please describe this association.',
        hasObligations: 'Does your relationship with this foreign national influence your actions or obligate you in any way, now or in the future?',
      },
      para: {
        intro1: 'This section asks for information regarding any foreign nationals with whom you or your spouse, legally-recognized partner, or person with whom you are in a committed, spouse-like relationship have had contact in the past five years. (Only report information prior to your 18th birthday if necessary to report a minimum of 2 years of information.) Do not list your spouse; legally-recognized partner from a civil union, domestic partnership, or common law marriage; person you are in a committed, spouse-like relationship with; or relatives you\'ve listed previously on this form.',
        intro2: 'For this section:',
        introItem1: '* A foreign national is any person who is not a citizen or national of the United States. A foreign national may live in the United States or another country. The United States is comprised of the 50 U.S. states, District of Columbia, and U.S. territories.',
        introItem2: '* Do not list dual U.S. citizens (a U.S. citizen who is a citizen of another country at the same time).',
        introItem3: '* Do not list foreign nationals with whom you only had contact while on official business for the U.S. Government.',
        introItem4: '* Do not list foreign nationals who you have previously listed on this form under the Relatives section.',
        introItem5: '* Report the information you currently know about the foreign national individual. Do not contact the foreign national to ask about information being collected on this form.',
        introItem6: '* Contact is defined as communication that is in person; by written correspondence, telephone, electronic media (e.g., email, text, social media, internet, etc.); or other method.',
        includes:
          'Include associates as well as relatives, not previously listed in the relatives section.',
        definition:
          'A foreign national is defined as any person who is not a citizen or national of the U.S.',
        or: 'or',
        checkall: 'Check all that apply',
      },
      label: {
        explain: 'Please explain.',
        idk: "I don't know",
        idkname: "I don't know their name",
        yes: 'Yes',
        no: 'No',
        inperson: 'In person',
        telephone: 'Telephone',
        electronic: 'Electronic (such as email, texting, chat rooms, etc)',
        written: 'Written correspondence',
        daily: 'Daily',
        weekly: 'Weekly',
        monthly: 'Monthly',
        quarterly: 'Quarterly',
        annually: 'Annually',
        professional: 'Professional or business',
        personal: 'Personal (such as family ties, friendship, affection, common interests, etc)',
        obligation: 'Obligation (provide explanation)',
        other: 'Other (provide explanation)',
        confirmation: 'Are you sure you would like to change your answer? This will remove any data currently entered.',
      },
      help: {
        branch: {
          title: 'Need help determining if you know any foreign nationals?',
          message: 'If you know anyone who is not a U.S. citizen or national then please click "yes"',
          note:
            'Note: A foreign national is defined as any person who is not a citizen or national of the U.S.',
        },
        firstcontact: {
          title: 'Let us know when you first met this person',
          message:
            'If you are not sure of the exact date give us your best guess and check the "Estimated" checkbox.',
          note: '',
        },
        lastcontact: {
          title: 'Tell us when you last had contact with this person',
          message:
            'Note: If you are not sure of the exact date give us your best guess and check the "Estimated" checkbox',
          note: '',
        },
        methods: {
          title: 'All of the ways you communicated with this person',
          message: 'Electronic includes social media.',
          note: '',
        },
        frequency: {
          title: 'Need help with the frequency of your communication?',
          message: 'Select the appropriate frequency of your correspondence',
          note: '',
        },
        relationship: {
          title: 'Need help with your relationship with this foreign national?',
          message: 'Check all the which apply to your relationship with the individual',
          note: '',
        },
        aliases: {
          title:
            'If this person has a nickname, a different maiden name, or used any other names answer "Yes"',
          message: 'If this person used multiple other names you will list each one separately.',
          note: '',
        },
        citizenship: {
          title: 'List all citizenships this person has',
          message:
            'You can provide multiple citizenships in this question.  Selected values will appear below the country selection.',
          note: '',
        },
        birthdate: {
          title: 'Need help with their date of birth?',
          message: 'Provide the approximate date of birth of the individual',
          note: 'Note: If you do not know then you may select "I don\'t know"',
        },
        birthplace: {
          title: 'Need help with their place of birth?',
          message: 'Provide the place of birth of the individual',
          note: 'Note: If you do not know then you may select "I don\'t know"',
        },
        address: {
          title: 'Need help with their current address?',
          message: 'Provide their most recent address',
          note: 'Note: If you do not know then you may select "I don\'t know"',
        },
        employer: {
          title: 'Need help with the employer?',
          message: 'Provide the name of their most recent employer',
          note: 'Note: If you do not know then you may select "I don\'t know"',
        },
        employeraddress: {
          title: 'Provide the address of their most recent employer',
          message: 'Note: If you do not know then you may select "I don\'t know".',
          note: '',
        },
        hasaffiliations: {
          title: 'Does this person have any affiliations?',
          message:
            'If the person has a relationship with a foreign government, military, security, defense industry, or intelligence service then select "yes"',
          note: '',
        },
        affiliations: {
          title: 'Need help describing their affiliations?',
          message: 'Describe the individuals relationship(s) with the foreign affiliations',
          note: '',
        },
      },
      collection: {
        summary: {
          title: 'Summary of foreign contacts',
          item: 'Foreign national',
          unknown: 'Provide the foreign national below',
        },
        appendTitle:
          'Do you have another instance in which you\'ve had contact with a foreign national in the past five years with whom you:',
        appendMessage: [
          '- Had feelings of affection, or',
          '- Had a romantic relationship, or',
          '- Were bound by social, moral, financial, or legal obligations, or',
          '- Shared information about yourself that, if known, could be used to influence you to act against the interests of the U.S. government.',
          '(Answer "Yes" if one or more of the bulleted answers apply.)',
        ],
        append: 'Add another association',
      },
    },
    spouseContacts: {
      heading: {
        title:
          'Does your spouse; legally-recognized partner from a civil union, domestic partnership, common law marriage; or, the person with whom you are in a committed, spouse-like relationship have a foreign national contact that influences your actions or obligates you in any way, now or in the future?',
        listedPreviously: 'Did you list this foreign national above?',
        name: 'What is the foreign national\'s name?',
        firstcontact: 'When was your first contact with this foreign national?',
        lastcontact: 'When was your last contact with this foreign national?',
        methods: 'What methods do you and this foreign national use to contact one another? (Select all that apply.)',
        frequency: 'How often are you in contact with this foreign national?',
        relationship: 'What is your relationship with this person?',
        spouseRelationship: 'What is the relationship of this foreign national to your spouse, legally-recognized partner, or the person with whom you are in a committed, spouse-like relationship?',
        aliases: 'Has this foreign national ever used another name (for example, aliases, nicknames, or a maiden name)?',
        aliases2: 'Is there another name this foreign national uses or used (for example, aliases, nicknames, or a maiden name)?',
        aliasname: 'What other name have they used?',
        nameDescription: 'Which of the following best describes this name?',
        citizenship: 'Provide country(ies) of citizenship for this foreign national (Select all that apply.)',
        birthdate: 'What is their date of birth?',
        birthplace: 'Where were they born?',
        idkBirthplace: 'Provide explanation regarding unknown birthplace',
        employer:
          'Who does this foreign national work for? (If they are unemployed, provide the name of their most recent employer.)',
        neverWorked: 'Never Worked',
        occupation: 'If known, what is this foreign national\'s occupation?',
        employerAddress:
          'Is this employer located in the U.S.?',
        employerAddressDomesticTitle:
          "What is the employer's address?",
        employerAddressForeignTitle:
          'Where is the employer located?',
        foreignDisciplines: 'Is this person associated with any of the following foreign disciplines? (Select all that apply)',
        hasaffiliations:
          'Is this foreign national affiliated with a foreign government, military, security, defense industry, or intelligence service?',
        affiliations:
          "Describe the contact's relationship with the foreign government, military, security, defense industry, or intelligence service",
        explanation: 'Please explain.',
        howCitizenshipAcquired: 'How did this person become a citizen of a foreign country? (For example, they applied for it or they acquired it through their parents or grandparents.)',
        address: 'Does this foreign national currently live in the U.S.?',
        addressDomesticTitle: 'What is their address?',
        addressForeignTitle: 'Where do they live?',
        email: 'What is the foreign national’s email address?',
        telephone: 'What is the foreign national’s phone number?',
        foreignAssociationDescription: 'Please describe this association.',
        hasObligations: 'Why do you feel the contact between this foreign national and your spouse, legally-recognized partner, or the person with whom you are in a committed, spouse-like relationship influences your actions or obligates you in any way, now or in the future?',

      },
      para: {
        intro1: 'This section asks for information regarding any foreign nationals with whom you or your spouse, legally-recognized partner, or person with whom you are in a committed, spouse-like relationship have had contact in the past five years. (Only report information prior to your 18th birthday if necessary to report a minimum of 2 years of information.) Do not list your spouse; legally-recognized partner from a civil union, domestic partnership, or common law marriage; person you are in a committed, spouse-like relationship with; or relatives you\'ve listed previously on this form.',
        intro2: 'For this section:',
        introItem1: '* A foreign national is any person who is not a citizen or national of the United States. A foreign national may live in the United States or another country. The United States is comprised of the 50 U.S. states, District of Columbia, and U.S. territories.',
        introItem2: '* Do not list dual U.S. citizens (a U.S. citizen who is a citizen of another country at the same time).',
        introItem3: '* Do not list foreign nationals with whom you only had contact while on official business for the U.S. Government.',
        introItem4: '* Do not list foreign nationals who you have previously listed on this form under the Relatives section.',
        introItem5: '* Report the information you currently know about the foreign national individual. Do not contact the foreign national to ask about information being collected on this form.',
        introItem6: '* Contact is defined as communication that is in person; by written correspondence, telephone, electronic media (e.g., email, text, social media, internet, etc.); or other method.',
        includes:
          'Include associates as well as relatives, not previously listed in the relatives section.',
        definition:
          'A foreign national is defined as any person who is not a citizen or national of the U.S.',
        or: 'or',
        checkall: 'Check all that apply',
      },
      label: {
        explain: 'Please explain.',
        idk: "I don't know",
        idkname: "I don't know their name",
        yes: 'Yes',
        no: 'No',
        inperson: 'In person',
        telephone: 'Telephone',
        electronic: 'Electronic (such as email, texting, chat rooms, etc)',
        written: 'Written correspondence',
        daily: 'Daily',
        weekly: 'Weekly',
        monthly: 'Monthly',
        quarterly: 'Quarterly',
        annually: 'Annually',
        professional: 'Professional or business',
        personal: 'Personal (such as family ties, friendship, affection, common interests, etc)',
        obligation: 'Obligation (provide explanation)',
        other: 'Other (provide explanation)',
        confirmation: 'Are you sure you would like to change your answer? This will remove any data currently entered.',
      },
      help: {
        branch: {
          title: 'Need help determining if you know any foreign nationals?',
          message: 'If you know anyone who is not a U.S. citizen or national then please click "yes"',
          note:
            'Note: A foreign national is defined as any person who is not a citizen or national of the U.S.',
        },
        firstcontact: {
          title: 'Let us know when you first met this person',
          message:
            'If you are not sure of the exact date give us your best guess and check the "Estimated" checkbox.',
          note: '',
        },
        lastcontact: {
          title: 'Tell us when you last had contact with this person',
          message:
            'Note: If you are not sure of the exact date give us your best guess and check the "Estimated" checkbox',
          note: '',
        },
        methods: {
          title: 'All of the ways you communicated with this person',
          message: 'Electronic includes social media.',
          note: '',
        },
        frequency: {
          title: 'Need help with the frequency of your communication?',
          message: 'Select the appropriate frequency of your correspondence',
          note: '',
        },
        relationship: {
          title: 'Need help with your relationship with this foreign national?',
          message: 'Check all the which apply to your relationship with the individual',
          note: '',
        },
        aliases: {
          title:
            'If this person has a nickname, a different maiden name, or used any other names answer "Yes"',
          message: 'If this person used multiple other names you will list each one separately.',
          note: '',
        },
        citizenship: {
          title: 'List all citizenships this person has',
          message:
            'You can provide multiple citizenships in this question.  Selected values will appear below the country selection.',
          note: '',
        },
        birthdate: {
          title: 'Need help with their date of birth?',
          message: 'Provide the approximate date of birth of the individual',
          note: 'Note: If you do not know then you may select "I don\'t know"',
        },
        birthplace: {
          title: 'Need help with their place of birth?',
          message: 'Provide the place of birth of the individual',
          note: 'Note: If you do not know then you may select "I don\'t know"',
        },
        address: {
          title: 'Need help with their current address?',
          message: 'Provide their most recent address',
          note: 'Note: If you do not know then you may select "I don\'t know"',
        },
        employer: {
          title: 'Need help with the employer?',
          message: 'Provide the name of their most recent employer',
          note: 'Note: If you do not know then you may select "I don\'t know"',
        },
        employeraddress: {
          title: 'Provide the address of their most recent employer',
          message: 'Note: If you do not know then you may select "I don\'t know".',
          note: '',
        },
        hasaffiliations: {
          title: 'Does this person have any affiliations?',
          message:
            'If the person has a relationship with a foreign government, military, security, defense industry, or intelligence service then select "yes"',
          note: '',
        },
        affiliations: {
          title: 'Need help describing their affiliations?',
          message: 'Describe the individuals relationship(s) with the foreign affiliations',
          note: '',
        },
      },
      collection: {
        summary: {
          title: 'Summary of foreign contacts',
          item: 'Foreign national',
          unknown: 'Provide the foreign national below',
        },
        appendTitle:
          'Do you have another instance in which your spouse; legally-recognized partner from a civil union, domestic partnership, common law marriage; or, the person with whom you are in a committed, spouse-like relationship has a foreign national contact that influences your actions or obligates you in any way, now or in the future?',
        appendMessage: [
          'Do you have another instance in which your spouse; legally-recognized partner from a civil union, domestic partnership, common law marriage; or, the person with whom you are in a committed, spouse-like relationship has a foreign national contact that influences your actions or obligates you in any way, now or in the future?',
        ],
        append: 'Add another association',
      },
    },
    business: {
      intro: {
        title: 'Section 27:  Foreign Business Affairs and Foreign Government Activities',
        intro: 'This section asks for information regarding you and your immediate family members\' activities with foreign-owned businesses and foreign governments. These activities could be business related, for professional endeavors, or for personal reasons.',
        prefix: 'For this section:',
        introItem1: 'An immediate family member is a spouse; legally-recognized partner from a civil union, domestic partnership, or common law marriage; parent; stepparent; sibling; half- or step-sibling; child (including adopted and foster); stepchild; guardian, or person with whom you are in a committed, spouse-like relationship.',
        introItem2: 'For purposes of this form, the term "committed, spouse-like relationship" is defined as a relationship between two people who are not in a legally-recognized marriage, union, or domestic partnership, present themselves as a couple, and live together continuously.',
        introItem3: 'Foreign means non-U.S. -- that is, outside of the 50 U.S. states, the District of Columbia, and the U.S. territories.',
        introItem4: 'A foreign-owned business is a private business or company owned or controlled by a foreign non-government entity. It may or may not be located in the U.S.',
        introItem5: 'A foreign government refers to a non-U.S. government, its agencies, and its employees or representatives. Examples of foreign government agencies include foreign embassies, consulates, military or armed forces, intelligence services, or security services.',
        introItem6: 'A foreign organization is a foreign entity that is not a foreign-owned business or part of a foreign government.',
        introItem7: 'A foreign national is any person who is not a citizen or national of the U.S.',
      },
      advice: {
        heading: {
          title:
            'Have you advised, supported, or consulted for any foreign-owned business or foreign organization in the past five years? (Answer “No” if your advice, support, or consultation was part of U.S. military or government business.)',
          description: 'What type of advice, support, or consultation do or did you provide the foreign-owned business or foreign organization?',
          name: 'Who did you give this advice, support, or consultation to?',
          role: 'What is or was this person\'s role in the foreign-owned business or foreign organization?',
          organization:
            'What is the name of the foreign-owned business or foreign organization?',
          country: 'What country is this foreign-owned business or foreign organization associated with?',
          dates: 'When did you give this advice, support, or consultation?',
          receivedCompensation: 'Did you receive any compensation for your advice, support, or consultation?',
          compensation: 'What type of compensation did you receive? (Include the monetary value of this compensation in U.S. dollars, if applicable.)',
        },
        label: {
          idk: 'I don\'t know',
        },
        para: {
          or: 'or',
          branch:
            'Answer **"No"** if **all** your advice or support was authorized pursuant to official U.S. Government business.',
        },
        help: {
          description: {
            title: 'Need help with the description?',
            message: 'Provide how the support was provided',
            note: '',
          },
          organization: {
            title: 'Need help with the organization name?',
            message: 'Provide the name of the business',
            note: '',
          },
          country: {
            title: 'Need help with the country of origin?',
            message: 'Provide the country where the business is based',
            note: '',
          },
          dates: {
            title: 'Estimate the date if unsure',
            message:
              'If you are not sure of the exact dates give us your best guess and check the "Estimated" checkbox.',
            note: '',
          },
          compensation: {
            title: 'Need help with compensation?',
            message:
              'Any monetary, favor, trade, or other type of exchange for services render constitutes as compensation',
            note: '',
          },
        },
        collection: {
          summary: {
            title: 'Summary of foreign business advice',
            item: 'Advice',
            unknown: 'Provide details of foreign business advice below',
          },
          appendTitle:
            'Do you have another instance in which you advised, supported, or consulted for a foreign-owned business or foreign organization in the past five years? (Answer “No” if your advice, support, or consultation was part of U.S. military or government business.)',
          appendMessage: [
            'Answer **"No"** if all your advice or support was authorized pursuant to official U.S. Government business.',
          ],
          append: 'Add another instance of advice/support',
        },
      },
      family: {
        heading: {
          title:
            'Has a foreign government official asked you or any of your family members listed below for advice or to be a consultant (paid or unpaid; formally or informally) in the past five years?',
          titleItem1: 'Spouse or legally-recognized partner',
          titleItem2: 'Person with whom you are in a committed, spouse-like relationship',
          titleItem3: 'Parent or Stepparent',
          titleItem4: 'Sibling, Step-sibling, or Half-sibling',
          titleItem5: 'Child (including adopted and foster) or Stepchild',
          whoWasAsked: 'Who was asked by a foreign government official for advice or to be a consultant (paid or unpaid; formally or informally) in the past five years? (If more than one, select one. There will be an opportunity to input multiple entries.)',
          familyName: 'What is your family member\'s name?',
          name: 'What is the name of the foreign government official who asked you or the family member you listed above for advice or consultation?',
          agency: 'What is the name of the foreign government agency this foreign government official is or was associated with?',
          country: 'Which foreign government is or was this foreign government official associated with?',
          date: 'When did this foreign government official ask for this advice or consultation?',
          circumstances: 'What were the circumstances? (Include what the foreign government official wanted advice or consultation on, where they asked for it, and any other important details.)',
        },
        label: {
          idk: 'I don\'t know',
        },
        para: {
          or: 'or',
          branch: [
            'For this question, "Immediate Family" means your spouse or legally recognized civil union/domestic partner, parents, step-parents, siblings, half and step-siblings, children, step-children, and cohabitant.',
            'Answer **"No"** if all the advice or support was authorized pursuant to official U.S. Government business.',
          ],
        },
        help: {
          branch: {
            title: 'Need help determining if you have provided advice to foreign businesses?',
            message:
              'If you have provided any advice to a foreign individual or business then select "yes"',
            note:
              'Note: Answer **"no"** if **all** your advice or support was authorized pursuant to official U.S. Government business.',
          },
          agency: {
            title: 'Need help with the agency name?',
            message: 'Provide the agency name',
            note: '',
          },
          country: {
            title: 'Need help with the affiliated country?',
            message: 'Provide the country the request was affiliated with',
            note: '',
          },
          date: {
            title: 'Estimate the date if unsure',
            message:
              'If you are not sure of the exact date give us your best guess and check the "Estimated" checkbox.',
            note: '',
          },
          circumstances: {
            title: 'Need help with the circumstances?',
            message: 'Provide all circumstances of the request',
            note: '',
          },
        },
        collection: {
          summary: {
            title: 'Summary of family foreign business advice',
            item: 'Advice',
            unknown: 'Provide details of family foreign business advice below',
          },
          appendTitle:
            'Do you have another instance in which a foreign government official asked you or a family member listed below for advice or to be a consultant (paid or unpaid; formally or informally) in the past five years?',
          appendMessage: [
            '- Spouse or legally-recognized partner',
            '- Person with whom you are in a committed, spouse-like relationship',
            '- Parent or Stepparent',
            '- Sibling, Step-sibling, or Half-sibling',
            '- Child (including adopted and foster) or Stepchild',
          ],
          append: 'Add another instance of advice/support',
        },
      },
      employment: {
        heading: {
          title:
            'Has a foreign national offered you a job, asked you to consider working for them, or asked you to be a business consultant in the past five years?',
          name: 'What is the name of the foreign national who made the offer or request?',
          description: 'What type of work does or did this foreign national want you to do? (Provide details about the specific job, business proposition, or consulting work.)',
          date: 'When did this foreign national make this offer or request?',
          address: 'Was this offer or request made to you in the U.S.?',
          addressDomesticTitle: 'Where did this take place?',
          addressForeignTitle: 'Where did this take place?',
          accepted: 'Did you accept the offer or request?',
          acceptedDate: 'When did you accept this offer or request?',
          performedService: 'Did you perform any services or work since accepting this offer or request?',
          datesPerformed: 'When did you perform these services or work for this foreign national?',
          compensation: 'What compensation did you receive for these services or work? (If monetary, provide the amount in U.S. dollars.)',
          hasOngoingObligations: 'Do you have any ongoing obligations to this foreign national?'

        },
        label: {
          explanation: 'Please explain',
          address: 'Did this occur in the United States?',
          idk: 'I don\'t know',
        },
        para: {
          or: 'or',
        },
        help: {
          branch: {
            title: 'Need help determining if you were offered a job?',
            message: 'If you were offered a foreign job select "yes"',
            note: '',
          },
          description: {
            title: 'Need help describing the offer?',
            message: 'Describe the position offered.',
            note: '',
          },
          date: {
            title: 'Estimate the date if unsure',
            message:
              'If you are not sure of the exact date give us your best guess and check the "Estimated" checkbox.',
            note: '',
          },
          address: {
            title: 'Need help with the location?',
            message: 'Provide the address of the location where the offer took place',
            note: '',
          },
          accepted: {
            title: 'Need help with describing the acceptance?',
            message: [
              'If you did not accept the offer please state this.',
              'If you did accept the offer please describe why it was accepted.',
            ],
            note: '',
          },
        },
        collection: {
          summary: {
            title: 'Summary of foreign business job offers',
            item: 'Offer',
            unknown: 'Provide details of foreign business job below',
          },
          appendTitle:
            'Do you have another instance in which a foreign national offered you a job, asked you to consider working for them, or asked you to be a business consultant in the past five years?',
          append: 'Add another job offer',
        },
      },
      ventures: {
        heading: {
          title:
            'Have you had any business venture with a foreign national in the past five years that you did not report above? (Examples of business ventures include owning or co-owning a business, serving as a business consultant, or providing financial support.)',
          name: 'What is the name of the foreign national with whom you had a business venture?',
          address: 'Does this foreign national currently live in the U.S.?',
          addressDomesticTitle: 'Where do they live?',
          addressForeignTitle: 'Where do they live?',
          citizenship: 'Provide country(ies) of citizenship for this foreign national. (Select all that apply.)',
          description: 'What is or was this business venture? (Describe the business venture, what service does it or did it provide, and any other important details.)',
          relationshipPvq: 'What is your relationship with this foreign national?',
          dates: 'How long were you involved in this business venture?',
          role: 'What is or was your role in this business venture?',
          association: 'Provide the nature of the association with this business venture',
          position: 'Provide the position you held',
          service: 'Provide the service you provided',
          support: 'How much financial support (in U.S. dollars) did you provide?',
          compensation: 'What type of compensation did you receive for your service? (If monetary, provide the amount in U.S. dollars.)',
          explanation: 'Please explain',
          financialSupportEstimated: 'Estimated'
        },
        label: {
          idk: 'I don\'t know',
        },
        para: {
          or: 'or',
          branch: ['Own, co-own, serve as a business consultant, provide financial support, etc.'],
        },
        help: {
          branch: {
            title: 'Need help with the business venture?',
            message:
              'If you have, or are currently, associated with a foreign business venture select "yes"',
            note: '',
          },
          address: {
            title: "Need help with the foreign national's address?",
            message: 'Provide the current address of the foreign national',
            note: '',
          },
          citizenship: {
            title: 'List all citizenships this person has',
            message: 'You can provide multiple citizenships in this question.',
            note: '',
          },
          description: {
            title: 'Need help describing the business venture?',
            message: 'Provide an accurate description of the business venture',
            note: '',
          },
          relationship: {
            title: 'Need help with the relation to the foreign national?',
            message: 'Provide the relationship to the foreign national',
            note: '',
          },
          dates: {
            title: 'Estimate the date if unsure',
            message:
              'If you are not sure of the exact date give us your best guess and check the "Estimated" checkbox.',
            note: '',
          },
          association: {
            title: 'Need help with the association to the venture?',
            message: 'Provide a description of how you were associated to the business venture',
            note: '',
          },
          position: {
            title: 'Need help with the position?',
            message: 'Provide the position you held',
            note: '',
          },
          service: {
            title: 'Need help with the service provided?',
            message: 'Provide how the service you provided',
            note: '',
          },
          support: {
            title: 'Need help describing the financial support?',
            message: 'Provide any financial support that was provided',
            note: '',
          },
          compensation: {
            title: 'Need help describing the compensation?',
            message:
              'Any monetary, favor, trade, or other type of exchange for services render constitutes as compensation',
            note: '',
          },
        },
        collection: {
          summary: {
            title: 'Summary of foreign business ventures',
            item: 'Venture',
            unknown: 'Provide details of foreign business ventures below',
          },
          appendTitle:
            'Do you have another business venture with a foreign national in the past five years that you haven\'t reported above? (Examples of business ventures include owning or co-owning a business, serving as a business consultant, or providing financial support.)',
          appendMessage: [
            'Own, co-own, serve as a business consultant, provide financial support, etc.',
          ],
          append: 'Add another business venture',
        },
      },
      conferences: {
        heading: {
          title:
            'Have you in the last seven (7) years attended or participated in any conferences, trade shows, seminars, or meetings outside the U.S.?',
          description: 'Provide the name and description of the event',
          sponsor: 'Provide the name of sponsoring organization',
          city: 'Provide the city where the event was held',
          country: 'Provide the country where the event was held',
          dates: 'Provide the dates for the event',
          purpose: 'Provide the purpose of the event',
          contact:
            'Was there any subsequent contact with any foreign nationals as a result of the event?',
          contact2: 'Do you have another subsequent contact to report for this event?',
          explanation: 'Provide explanation',
        },
        para: {
          branch: [
            'Do not include those you attended or participated in on official business for the U.S. government.',
          ],
        },
        help: {
          branch: {
            title: 'Need help determining if you have been to a foreign conference?',
            message:
              'If you have to been to a conference not in the U.S. outside of official U.S. government business select "yes".',
            note: '',
          },
          description: {
            title: 'Need help with the description?',
            message: 'Provide the name of the conference as well as a general description.',
            note: '',
          },
          sponsor: {
            title: 'Need help with the sponsoring organization?',
            message: 'Provide the name(s) of the sponsoring organizations of the conference.',
            note: '',
          },
          city: {
            title: 'Need help with the city?',
            message: 'Provide the city the conference was located.',
            note: '',
          },
          country: {
            title: 'Need help with the country?',
            message: 'Provide the country the conference was located.',
            note: '',
          },
          dates: {
            title: 'Try looking up the event, this could help you find the dates',
            message:
              'If you can\'t find the exact date give us your best guess and check the "Estimated" checkbox.',
            note: '',
          },
          purpose: {
            title: 'Need help with the purpose of the conference?',
            message: 'Describe the purpose of the event.',
            note: '',
          },
          contact: {
            title: 'Contact after the event',
            message:
              'Did you have contact with any foreign nationals after this event? If so answer "Yes".',
            note: '',
          },
          explanation: {
            title: 'Need help with this explanation?',
            message: 'Tell us all the circumstances and/or outcome of the contact.',
            note: '',
          },
        },
        collection: {
          summary: {
            title: 'Summary of foreign business conferences',
            item: 'Event',
            unknown: 'Provide details of the event below',
          },
          appendTitle:
            'Have you in the last seven (7) years, attended or participated in any additional conferences, trade shows, seminars, or meetings outside the U.S.?',
          appendMessage: [
            'Do not include those you attended or participated in on official business for the U.S. government.',
          ],
          append: 'Add another event',
        },
      },
      contact: {
        heading: {
          title:
            'Have you or any of your immediate family members had contact with a foreign government agency or its representatives in the past five years? (Report contact regardless if it was inside or outside of the U.S. Answer “No” if the contact was for a visa application; during a routine border crossing while traveling on a U.S. passport; or, while performing official U.S. Government business or military duty.)',
          whoContacted: 'Who had contact with a foreign government agency or its representatives? (If more than one, select one. There will be an opportunity to input multiple entries.)',
          name: 'What is the name of the family member?',
          address: 'Did this contact take place in the U.S.?',
          addressDomesticTitle: 'Where did this contact take place?',
          addressForeignTitle: 'Where did this contact take place?',
          date: 'When was the last time you or this family member had contact with this foreign government agency or its representatives?',
          governments: 'What country is the foreign government agency or its representatives associated with?',
          agencyType: 'What type of foreign government agency is this?',
          agencyName: 'What is the name of the foreign government agency? (Do not use acronyms or abbreviations.)',
          establishment:
            'Provide the type of establishment (such as embassy, consulate, agency, military service, intelligence or security service, etc.) involved',
          representatives: 'Provide the names of foreign representatives involved in contact',
          purpose: 'Why did you or this family member have contact with this foreign government agency or its representatives?',
          representativeName: 'What is the name of the representative from this foreign government agency you or this family member had contact with?',
          hassubsequent:
            'Was there any subsequent contact initiated by you, your immediate family member, or a representative of the foreign organization?',
          hassubsequent2: 'Do you have another subsequent contact to report for this event?',
          subsequent: 'Provide the purpose of the subsequent contact',
          recent: 'When was the last time you or this family member had contact with this foreign government agency or its representatives?',
          future: 'Provide plans for future contact',
          explanation: 'Please explain',
          hasFuturePlansToContact: 'Do you or an immediate family member have future plans to contact a foreign government agency or its representatives?',
        },
        para: {
          or: 'or',
          intro:
            'For this question, "Immediate Family" means your spouse, parents, step-parents, siblings, half and step-siblings, children, stepchildren, and cohabitant.',
          branch: [
            'Such as  embassy, consulate, agency, military service, intelligence or security service, etc.',
            'Answer **"No"** if the contact was for routine visa applications and border crossings related to either official U.S.  Government travel, foreign travel on a U.S. passport, or as a U.S. military service member in conjunction with a U.S. Government military duty.',
          ],
        },
        label: {
          idk: ' I don\'t know',
          location: 'Did this contact take place in the United States of America?',
        },
        help: {
          branch: {
            title: 'Need help determining if you have any foreign government contact?',
            message: 'If you have any foreign government contact then select "yes".',
            note: '',
          },
          location: {
            title: 'Need help with the location?',
            message: 'Provide the location of the contact.',
            note: '',
          },
          date: {
            title: 'Estimate the date if unsure',
            message:
              'If you are not sure of the exact date give us your best guess and check the "Estimated" checkbox.',
            note: '',
          },
          governments: {
            title: 'All governments involved in this contact',
            message: 'You can provide multiple governments in this question.',
            note: '',
          },
          establishment: {
            title: 'Need help with the establishment?',
            message: 'Provide the establishment.',
            note: '',
          },
          representatives: {
            title: 'Need help with the representatives?',
            message: 'Provide the representatives.',
            note: '',
          },
          purpose: {
            title: 'Need help with the purpose of contact?',
            message: 'Provide the purpose/circumstances of the contact.',
            note: '',
          },
          hassubsequent: {
            title: 'Any other contacts?',
            message: 'If there were any other contacts with the foreign organization select "Yes".',
            note: '',
          },
          subsequent: {
            title: 'Need help with the purpose of the subsequent contact?',
            message: 'Provide the purpose of the subsequent contact.',
            note: '',
          },
          recent: {
            title: 'Estimate the date if unsure',
            message:
              'If you are not sure of the exact date give us your best guess and check the "Estimated" checkbox.',
            note: '',
          },
          future: {
            title: 'Need help explaining future plans of contact?',
            message: 'Provide a description of any future plans of contact.',
            note: '',
          },
        },
        collection: {
          summary: {
            title: 'Summary of foreign government contacts',
            item: 'Contact',
            unknown: 'Provide details of contact below',
          },
          appendTitle:
            'Do you have another instance in which you or an immediate family member had contact with a foreign government agency or its representatives in the past five years? (Report regardless if contact was inside or outside of the U.S. Answer “No” if the contact was for a visa application; during a routine border crossing while traveling on a U.S. passport; or, while performing official U.S. Government business or military duty.)',
          appendMessage: [
            'Such as embassy, consulate, agency, military service, intelligence or security service, etc.',
            'Answer **"No"** if the contact was for routine visa applications and border crossings related to either official U.S. Government travel, foreign travel on a U.S. passport, or as a U.S. military service member in conjunction with a U.S. Government military duty.',
          ],
          append: 'Add another contact',
        },
      },
      sponsorship: {
        heading: {
          title:
            'Have you sponsored a foreign national to the U.S. in the past five years? (For example, as a student, for work, or for permanent residence.)',
          reason: 'Why did you sponsor this foreign national?',
          name: 'What is the name of the foreign national you sponsored?',
          birthdate: 'What is their date of birth?',
          birthplace: 'Where was this person born?',
          address: 'Is this foreign national currently living in the U.S.?',
          addressDomesticTitle: 'Where do they live?',
          addressForeignTitle: 'Where do they live?',
          citizenship: 'Provide country(ies) of citizenship for this person. (Select all that apply.)',
          workedWithPrivateOrganization: 'Did you work with an organization to arrange this sponsorship?',
          organization:
            'What is the name of this organization that arranged the sponsorship?',
          organizationAddress:
            'Is this organization located in the U.S.?',
          organizationAddressDomesticTitle: 'What is the address?',
          organizationAddressForeignTitle: 'Where are they located?',
          dates: 'When did you sponsor this foreign national?',
          residence:
            'Provide the address of the sponsored foreign national while residing in the U.S.',
          stay: 'Provide the purpose of the stay in the U.S. for the sponsored foreign national',
          sponsorship: 'Provide the purpose of your sponsorship for the sponsored foreign national',
          explain: 'Please explain',
        },
        label: {
          idk: "I don't know",
          birthplace: 'Was this person born in the United States of America?',
        },
        para: {
          or: 'or',
        },
        help: {
          branch: {
            title: 'Foreign national defined:',
            message:
              'A foreign national is defined as any person who is not a citizen or national of the U.S.',
            note: '',
          },
          birthdate: {
            title: 'Estimate the date if unsure',
            message:
              'If you are not sure of the exact date give us your best guess and check the "Estimated" checkbox.',
            note: '',
          },
          birthplace: {
            title: 'Need help with the place of birth?',
            message: 'Provide the foreign nationals place of birth.',
            note: '',
          },
          address: {
            title: 'Acronyms:',
            message: 'APO - Army Post Office, FPO - Fleet Post Office.',
            note: '',
          },
          citizenship: {
            title: 'List all citizenships this person has',
            message:
              'You can provide multiple citizenships in this question.  Selected values will appear below the country selection.',
            note: '',
          },
          organization: {
            title: 'Need help with the organization?',
            message: 'Provide the organization name through which the sponsorship was arranged.',
            note: '',
          },
          organizationaddress: {
            title: "Try looking up the organization's name, this could help you find the address",
            message: 'If you can only find a phone number try calling and asking for the address.',
            note:
              'Acronyms: APO - Army Post Office, FPO - Fleet Post Office.',
          },
          dates: {
            title: 'Full date range the sponsored foreign national was in the U.S.',
            message:
              'If you are not sure of the exact dates give us your best guess and check the "Estimated" checkbox.',
            note: '',
          },
          residence: {
            title: 'Need help with the residence?',
            message: 'Provide the address of the sponsored foreign national.',
            note: '',
          },
          stay: {
            title: 'Need help with the purpose of the stay?',
            message: 'Provide the purpose for the stay within the U.S.',
            note: '',
          },
          sponsorship: {
            title: 'Need help with the purpose of the sponsorship?',
            message: 'Provide the purpose of the sponsorship.',
            note: '',
          },
        },
        collection: {
          summary: {
            title: 'Summary of foreign national sponsorship',
            item: 'Sponsorship',
            unknown: 'Provide details of sponsorship below',
          },
          appendTitle:
            'Do you have another instance in which you sponsored a foreign national to the U.S. in the past five years? (For example, as a student, for work, or for permanent residence.)',
          appendMessage: [],
          append: 'Add another sponsorship',
        },
      },
      political: {
        heading: {
          title: 'Have you ever held a political office in a foreign country?',
          position: 'What position did you hold?',
          dates: 'When did you hold this position?',
          country: 'What foreign country did you hold this political office in?',
          reason: 'Why did you hold political office in this foreign country?',
          explanation: 'Please explain',
          eligibility:
            'Are you currently eligible to hold political office in this foreign country?',
        },
        label: {
          idk: "I don't know",
          birthplace: 'Was this person born in the United States of America?',
        },
        para: {
          or: 'or',
        },
        help: {
          branch: {
            title: 'Need help determining if you have any foreign government sponsorship?',
            message: 'If you have any foreign government sponsorship then select "yes".',
            note: '',
          },
          position: {
            title: 'Need help with the position?',
            message: 'Provide the position held.',
            note: '',
          },
          dates: {
            title: 'Full date range you held this political office',
            message:
              'If you are not sure of the exact dates give us your best guess and check the "Estimated" checkbox.',
            note: '',
          },
          country: {
            title: 'Need help with the country involved?',
            message: 'Provide the country involved.',
            note: '',
          },
          reason: {
            title: 'Need help with the reason?',
            message: 'Describe the reason for these activities.',
            note: '',
          },
          eligibility: {
            title: 'Need help with your current eligibility?',
            message: 'Provide your current eligibility for the political office.',
            note: '',
          },
        },
        collection: {
          summary: {
            title: 'Summary of foreign political office',
            item: 'Office',
            unknown: 'Provide details of political office below',
          },
          appendTitle: 'Do you have another instance in which you held a political office in a foreign country?',
          appendMessage: [],
          append: 'Add another political office',
        },
      },
      voting: {
        heading: {
          title: 'Have you ever voted in a foreign election?',
          date: 'When did you vote in this foreign election?',
          country: 'What country was this foreign election in?',
          reason: 'Why did you vote in this foreign election?',
          explanation: 'Please explain',
          eligibility: 'Are you currently eligible to vote in a foreign country?',
        },
        help: {
          branch: {
            title: 'Need help determining if you have any foreign government sponsorship?',
            message: 'If you have any foreign government sponsorship then select "yes".',
            note: '',
          },
          date: {
            title: 'Estimate the date if unsure',
            message:
              'If you are not sure of the exact date give us your best guess and check the "Estimated" checkbox.',
            note: '',
          },
          country: {
            title: 'Need help with the country you voted in?',
            message: 'Provide the country name.',
            note: '',
          },
          reason: {
            title: 'Need help with the reason?',
            message: 'Describe the reason for these activities.',
            note: '',
          },
          eligibility: {
            title: 'Need help with your current eligibility?',
            message: 'Provide your current eligibility for voting.',
            note: '',
          },
        },
        collection: {
          summary: {
            title: 'Summary of foreign elections',
            item: 'Election',
            unknown: 'Provide details of election below',
          },
          appendTitle:
            'Do you have another instance in which you voted in a foreign election?',
          appendMessage: [],
          append: 'Add another election',
        },
      },
    },
    travel: {
      heading: {
        outside: 'Have you traveled outside the U.S. in the last past seven (7) years?',
        official:
          'Has your travel in the last (7) years been solely for U.S. Government business/military overseas assignment on official government orders?',
        country: 'Provide the country visited',
        dates: 'Provide the dates of your travel to this country',
        days: 'Provide the total number of days involved in the visit(s)',
        purpose: 'Provide the purpose of the travel to this country',
        questioned:
          'While traveling to, or in this country, were you questioned, searched, or otherwise detained (other than for normal customs requirements) by the local customs or security service officials when entering or leaving this country?',
        encounter:
          'While traveling to or in this country, were you involved in any encounter with the police?',
        contacted:
          'While traveling to or in this country, were you contacted by, or in contact with any person known or suspected of being involved or associated with foreign intelligence, terrorist, security, or military organizations?',
        counter:
          'While traveling to, or in this country, were you involved in any counterintelligence or security issues not reported?',
        interest:
          'While traveling to or in this country, were you contacted by, or in contact with anyone exhibiting excessive knowledge of or undue interest in you or your job?',
        sensitive:
          'While traveling to or in this country, were you contacted by, or in contact with anyone attempting to obtain classified information or unclassified, sensitive information?',
        threatened:
          'While traveling to, or in this country, were you threatened, coerced, or pressured in any way to cooperate with a foreign government official or foreign intelligence or security service?',
        explanation: 'Provide explanation',
      },
      para: {
        personal:
          'I.e., no personal trips in conjunction with the official U.S. Government business.',
        checkall: 'Check all that apply',
        explanation: 'If yes provide explanation.',
        timeframe: [
          'Respond for the time frame of the last seven (7) years, beginning with the most recent and working backwards.',
          'Do not list trips that ONLY involved travel on official U.S. Government business on official government orders, but you must include any personal trips made in conjunction with the official U.S. Government travel.',
        ],
      },
      label: {
        one: '1-5',
        six: '6-10',
        eleven: '11-20',
        twentyone: '21-30',
        more: 'More than 30',
        many: 'Many short trips',
        business: 'Business/professional',
        volunteer: 'Volunteer activities',
        education: 'Education',
        tourism: 'Tourism',
        conference: 'Trade shows, conferences, and seminars',
        family: 'Visit family or friends',
        other: 'Other',
      },
      help: {
        outside: {
          title: 'Have you traveled outside the U.S.?',
          message: 'This includes many short trips to the same country.',
          note: '',
        },
        official: {
          title: 'Please enter each trip over the past seven (7) years.',
          message:
            'List the places you’ve travel to over the past seven (7) years, starting with your most recent trip and working backwards.',
          note:
            'Be sure to include any personal trips made in conjunction with the official federal government travel. Do not list trips that ONLY involved travel on official federal government business on official government orders.',
        },
        country: {
          title: 'Need help with the country?',
          message: 'Provide the name of the country you visited.',
          note: '',
        },
        dates: {
          title: 'Estimate the date if unsure',
          message:
            'If you are not sure of the exact dates give us your best guess and check the "Estimated" checkbox.',
          note: '',
        },
        days: {
          title: 'How long your travel was',
          message:
            'Many short trips means a gap between trips that is less than 6 months. For a travel gap longer than 6 months add another travel item.',
          note: '',
        },
        purpose: {
          title: 'Need help with the purpose?',
          message: 'Provide the purpose of the visit.',
          note: '',
        },
        questioned: {
          title: 'Were you questioned during the visit?',
          message: 'Provide an explanation for the questioning.',
          note: '',
        },
        encounter: {
          title: 'Did you encounter the police during the visit?',
          message: 'Provide an explanation for police involvement.',
          note: '',
        },
        contacted: {
          title: 'Were you contacted of any suspicious people?',
          message: 'Provide an explanation of the contact.',
          note: '',
        },
        counter: {
          title: 'Were you involved in any security issues?',
          message: 'Provide a description of your participation or experience.',
          note: '',
        },
        interest: {
          title: 'Did anyone seem to have a strong interest in your visit?',
          message: 'Provide a description detailing the circumstances.',
          note: '',
        },
        sensitive: {
          title: 'Did anyone attempt to obtain sensitive information from you?',
          message: 'Provide an accurate description.',
          note: '',
        },
        threatened: {
          title: 'Any coercion or pressure from the foreign government?',
          message: 'Provide a detailed account of the circumstances.',
          note: '',
        },
      },
      collection: {
        summary: {
          title: 'Summary of foreign travel',
          item: 'Travel',
          unknown: 'Provide details of your travel below',
        },
        appendTitle:
          'Do you have additional travel outside the U.S. in the last seven (7) years for other than solely U.S. Government business on official government orders?',
        appendMessage: [],
        append: 'Add another travel',
      },
    },
  },
  intro: {
    title: 'Foreign associations',
    body:
      'You will be asked questions about your current and previous foreign associations and be asked to provide details if necessary.',
  },

  tour: {
    para: 'Take a guided tour through the section',
  },
  review: {
    para: 'View all the sections associated with foreign associations at once',
  },
  section: {
    name: 'Foreign associations',
  },
  subsection: {
    intro: 'Introduction',
    passport: 'U.S. passport information',
    contacts: 'Foreign contacts',
    activities: {
      label: 'Foreign activities',
      direct: 'Direct control',
      indirect: 'Indirect control',
      realestate: 'Real estate purchase',
      benefits: 'Foreign benefits',
      support: 'Foreign national support',
    },
    business: {
      label: 'Foreign business, professional activities, and government contacts',
      advice: 'Support provided',
      family: 'Immediate family foreign support',
      employment: 'Employment',
      ventures: 'Other business ventures',
      conferences: 'Event participation',
      contact: 'Immediate family contact',
      sponsorship: 'Foreign national sponsorship',
      political: 'Held political office',
      voting: 'Voting',
    },
    travel: 'Foreign countries you have visited',
    review: 'Review',
  },
  destination: {
    intro: 'Foreign intro',
    review: 'Review Foreign Associations',
    history: 'Your History',
    tbd: 'TBD',
    contacts: 'Foreign contacts',
    passport: 'U.S. passport information',
    activity: 'Foreign activities',
    'activities/direct': 'Direct control',
    'activities/indirect': 'Indirect control',
    'activities/realestate': 'Real estate purchase',
    'activities/benefits': 'Foreign benefits',
    'activities/support': 'Foreign national support',
    'activities/future': 'Future foreign interest',
    'activities/ongoingsupport': 'Foreign benefit eligible',
    'activities/current': 'Current foreign benefit',
    'activities/intro': 'Introduction',
    'business/intro': 'Introduction',
    'business/advice': 'Support provided',
    'business/family': 'Immediate family foreign support',
    'business/employment': 'Employment',
    'business/ventures': 'Other business ventures',
    'business/conferences': 'Event participation',
    'business/contact': 'Immediate family contact',
    'business/sponsorship': 'Foreign national sponsorship',
    'business/political': 'Held political office',
    'business/voting': 'Voting',
    travel: 'Foreign countries you have visited',
  },
  passport: {
    title: 'U.S. passport information',
    info: {
      text:
        'Provide the following information for the most recent U.S. passport you currently possess.',
      link: 'U.S. State Department passport help',
    },
    question: {
      title: 'Do you possess a U.S. passport (current or expired)?',
      yes: 'Yes',
      no: 'No',
    },
    label: {
      bookNumber: 'Passport number',
      book: 'Passport',
    },
    name: 'Provide the name in which passport was first issued',
    number: 'Provide your U.S. passport number',
    issued: 'Provide the issue date of the passport',
    expiration: 'Provide the expiration date of the passport',
    help: {
      number: {
        title: 'Passport',
        message:
          'U.S. Passport numbers must be nine alphanumeric characters (letters and numbers).',
        note: '',
      },
      issued: {
        title: 'Use the exact date',
        message: 'Enter the date on your passport.',
        note: '',
      },
      expiration: {
        title: 'Use the exact date',
        message: 'Enter the date on your passport.',
        note: '',
      },
    },
    branch: {
      help: {
        title: 'Need more information about the U.S. passport?',
        message: 'Select whether you possess a U.S. passport',
        note: '',
      },
    },
  },
  activities: {
    direct: {
      heading: {
        title:
          'Have you, your spouse or legally recognized civil union/domestic partner, cohabitant, or dependent children EVER had any foreign financial interests in which you or they have direct control or direct ownership?',
      },
      para: {
        intro: [
          'Foreign financial interest examples:  stocks, property, investments, bank accounts, ownership of corporate entities, corporate interests or exchange traded funds (ETFs) held in specific geographical or economic sectors.',
          'Exclude financial interests in companies or diversified mutual funds or diversified ETFs that are publicly traded on a U.S. exchange.',
        ],
        howAcquired: 'Such as purchase, gift, etc.',
      },
      collection: {
        summary: 'Provide your direct financial interests here',
        description: 'Summary of financial interests',
        appendTitle:
          'Do you, your spouse or legally recognized civil union/domestic partner, cohabitant, or dependent children have any additional foreign financial interests?',
        appendLabel: 'Add another direct interest',
        itemType: 'Interest',
      },
      help: {
        directControl: {
          title: '"Direct control" defined:',
          message:
            'Direct control means there are *no* intermediary or intervening factors between the foreign financial interest and the owner/controller.',
          note:
            'Example: You own a bakery in a foreign country and you directly control all aspects of the business such as pricing, baking, etc.',
        },
      },
      interest: {
        para: {
          checkAll: 'Check all that apply',
          howAcquired: 'Such as purchase, gift, etc.',
        },
        heading: {
          interestTypes: 'Specify',
          interestType: 'Provide the type of financial interest',
          acquired: 'Provide the date acquired',
          howAcquired: 'Provide how the financial interest was acquired',
          cost: 'Provide the cost (in U.S. dollars) at time of acquisition',
          value:
            'Provide the current value (in U.S. dollars) or the value at the time control or ownership was sold, lost or otherwise disposed of',
          relinquished: 'Provide the date control or ownership was relinquished',
          explanation:
            'Provide explanation of how interest control or ownership was sold, lost or otherwise disposed of',
        },
        label: {
          relinquishedNotApplicable: 'Not applicable',
          or: 'or',
          costEstimated: 'Estimated',
          valueEstimated: 'Estimated',
          interestTypes: {
            yourself: 'Yourself',
            spouse: 'Spouse or legally recognized civil union/domestic partner',
            cohabitant: 'Cohabitant',
            dependentChildren: 'Dependent children',
          },
        },
        help: {
          interestTypes: {
            title: 'Need help with the interest type field?',
            message: 'Check all that apply',
            note: '',
          },
          interestType: {
            title: 'Specify everyone who had a foreign financial interests?',
            message: 'Select all people involved with this specific foreign financial interests.',
            note: '',
          },
          acquired: {
            title: 'Estimate the date if unsure',
            message:
              'If you are not sure of the exact date give us your best guess and check the "Estimated" checkbox.',
            note: '',
          },
          howAcquired: {
            title: 'Need help with how the interest was acquired?',
            message: 'Provide how the financial interest was acquired',
            note: '',
          },
          cost: {
            title: 'Need help with the cost?',
            message: 'If you are not sure of the exact amount give us your best guess.',
            note: '',
          },
          value: {
            title: 'Need help with the value?',
            message: 'If you are not sure of the exact amount give us your best guess.',
            note: '',
          },
          relinquished: {
            title:
              'When you were no longer in control or an owner of this foreign financial interest',
            message:
              'If you are not sure of the exact date give us your best guess and check the "Estimated" checkbox.',
            note: '',
          },
          explanation: {
            title: 'Need help with this explanation?',
            message:
              'Tell us how you got rid of your ownership or control of this financial interest.',
            note: '',
          },
        },
        coOwner: {
          heading: {
            name: 'Provide full name of co-owner',
            address: "Provide co-owner's current address",
            countries: 'Provide co-owner’s country(ies) of citizenship',
            relationshipNature: 'Provide the nature of your relationship with the co-owner',
          },
          label: {
            address: 'This address is',
          },
          help: {
            countries: {
              title: "Need help with co-owner's country(ies) of citizenship?",
              message:
                'Tell us all of the citizenships this person has.  Selected values will appear below the country selection.',
              note: 'Note: You can provide multiple citizenships in this question.',
            },
            relationshipNature: {
              title: 'Need help with the nature of the relationship?',
              message: 'Provide the nature of your relationship with the co-owner',
              note: '',
            },
          },
        },
        coOwners: {
          heading: {
            hasCoOwners: 'Are there any co-owners of this foreign financial interest?',
            hasCoOwnersAppend:
              'Are there any additional co-owners of this foreign financial interest?',
          },
        },
      },
    },
    indirect: {
      heading: {
        title:
          'Have you, your spouse or legally recognized civil union/domestic partner, cohabitant, or dependent children EVER had any foreign financial interests that someone controlled on your behalf?',
      },
      collection: {
        summary: 'Provide your indirect financial interests here',
        description: 'Summary of financial interests',
        appendTitle:
          'Do you, your spouse or legally recognized civil union/domestic partner, cohabitant, or dependent children have any additional foreign financial interests controlled on your behalf?',
        appendLabel: 'Add another indirect interest',
        itemType: 'Interest',
      },
      help: {
        indirectControl: {
          title: '"Indirect control" defined:',
          message:
            'Indirect control means there *are* intermediary or intervening factors between the foreign financial interest and the owner/controller.',
          note:
            'Example: You own a bakery in a foreign country and have an employee directly control aspects of the business such as pricing, baking, etc.',
        },
      },
      interest: {
        para: {
          checkAll: 'Check all that apply',
          howAcquired: 'Such as purchase, gift, etc.',
        },
        heading: {
          interestTypes: 'Specify',
          interestType: 'Provide the type of financial interest',
          name:
            'Provide the name of the individual who controls this financial interest on your behalf',
          relationship: 'Provide this individual’s relationship to you',
          acquired: 'Provide the date the financial interest was acquired',
          howAcquired: 'Provide details regarding how it was acquired',
          cost: 'Provide the cost (in U.S. dollars) at time of acquisition',
          value:
            'Provide the current value (in U.S. dollars) or the value at the time control or ownership was sold, lost or otherwise disposed of',
          sold: 'Provide the date interest was sold, lost, or otherwise disposed of',
          explanation: 'Provide explanation if interest was sold, lost, or otherwise disposed of',
        },
        label: {
          firstname: 'First name',
          lastname: 'Last name',
          soldNotApplicable: 'Not applicable',
          or: 'or',
          costEstimated: 'Estimated',
          valueEstimated: 'Estimated',
          interestTypes: {
            yourself: 'Yourself',
            spouse: 'Spouse or legally recognized civil union/domestic partner',
            cohabitant: 'Cohabitant',
            dependentChildren: 'Dependent children',
          },
        },
        help: {
          interestTypes: {
            title: 'Specify everyone who had a foreign financial interests',
            message: 'Select all people involved with this specific foreign financial interest.',
            note: '',
          },
          interestType: {
            title: 'Need help with the indirect interest type?',
            message: 'Provide the type of financial interest',
            note: '',
          },
          name: {
            title: 'Need help with the name of the person?',
            message:
              'Provide the name of the individual who controls this financial interest on your behalf',
            note: '',
          },
          acquired: {
            title: 'Estimate the date if unsure',
            message:
              'If you are not sure of the exact date give us your best guess and check the "Estimated" checkbox.',
            note: '',
          },
          howAcquired: {
            title: 'Need help with how the interest was acquired?',
            message: 'Provide how the financial interest was acquired',
            note: '',
          },
          cost: {
            title: 'Need help with the cost?',
            message:
              'If you are not sure of the exact amount give us your best guess and check the "Estimated" checkbox.',
            note: '',
          },
          value: {
            title: 'Need help with the value?',
            message:
              'If you are not sure of the exact amount give us your best guess and check the "Estimated" checkbox.',
            note: '',
          },
          sold: {
            title: 'When you got rid of of this foreign financial interest',
            message:
              'If you are not sure of the exact date give us your best guess and check the "Estimated" checkbox.',
            note: '',
          },
          explanation: {
            title: 'Need help with this explanation?',
            message: 'Tell us how you got rid of of this foreign financial interest.',
            note: '',
          },
          relationship: {
            title: 'How do you know this person',
            message:
              'Let us know how you know this person and give us details of your relationship with them.',
            note: '',
          },
        },
        coOwner: {
          heading: {
            name: 'Provide full name of co-owner',
            address: 'Provide co-owner current address',
            countries: 'Provide co-owner’s country(ies) of citizenship',
            relationshipNature: 'Provide the nature of your relationship with the co-owner',
          },
          label: {
            address: 'This address is',
          },
          help: {
            countries: {
              title: "Need help with co-owner's country(ies) of citizenship?",
              message:
                'Tell us all of the citizenships this person has.  Selected values will appear below the country selection.',
              note: 'Note: You can provide multiple citizenships in this question.',
            },
            relationshipNature: {
              title: 'Need help with the nature of this relationship?',
              message:
                'Let us know how you know this person and give us details of your relationship with them.',
              note: '',
            },
          },
        },
        coOwners: {
          heading: {
            hasCoOwners:
              'Are there any co-owners of the foreign financial interest controlled on your behalf?',
            hasCoOwnersAppend:
              'Are there any additional co-owners for this foreign financial interest controlled on your behalf to report?',
          },
        },
      },
    },
    realestate: {
      heading: {
        title:
          'Have you, your spouse or legally recognized civil union/domestic partner, cohabitant, or dependent children EVER owned, or do you anticipate owning, or plan to purchase real estate in a foreign country?',
      },
      collection: {
        summary: 'Provide your real estate purchase here',
        description: 'Summary of financial purchase',
        appendTitle:
          'Do you have an additional instance of you, your spouse or legally recognized civil union/domestic partner, cohabitant, or dependent children EVER having owned, or anticipate owning, or planning to purchase real estate in a foreign country?',
        appendLabel: 'Add another real estate purchase',
        itemType: 'Purchase',
      },
      interest: {
        para: {
          checkAll: 'Check all that apply',
          howAcquired: 'Such as purchase, gift, etc.',
          realEstateType: 'Such as home, business, etc',
        },
        heading: {
          interestTypes: 'Specify',
          realEstateType: 'Provide the type of real estate property',
          address: 'Provide the location/address of property',
          acquired: 'Provide the date of purchase or to be acquired',
          howAcquired: 'Provide how the foreign real estate was or is to be acquired',
          cost: 'Provide the cost (in U.S. dollars) when sold or expected at time of acquisition',
          sold: 'Provide the date sold, if applicable',
        },
        label: {
          address: 'This address is',
          soldNotApplicable: 'Not applicable',
          or: 'or',
          costEstimated: 'Estimated',
          interestTypes: {
            yourself: 'Yourself',
            spouse: 'Spouse or legally recognized civil union/domestic partner',
            cohabitant: 'Cohabitant',
            dependentChildren: 'Dependent children',
          },
        },
        help: {
          purchaseDate: {
            title: 'There is a problem with the date',
            message: 'Date is prior to earliest date for yourself, your spouse, or a cohabitant.',
            note: '',
          },
          interestTypes: {
            title: 'Specify everyone who had a foreign financial interests',
            message: 'Select all people involved with this specific foreign financial interest.',
            note: '',
          },
          realEstateType: {
            title: 'Need help with the real estate interest type?',
            message: 'Provide the type of real estate interest',
            note: '',
          },
          acquired: {
            title: 'Estimate the date if unsure',
            message:
              'If you are not sure of the exact date give us your best guess and check the "Estimated" checkbox.',
            note: '',
          },
          howAcquired: {
            title: 'Need help with how the interest was acquired?',
            message: 'Provide how the financial interest was acquired',
            note: '',
          },
          cost: {
            title: 'Estimate the cost if unsure',
            message:
              'If you are not sure of the exact amount give us your best guess and check the "Estimated" checkbox.',
            note: '',
          },
          sold: {
            title: 'If the real estate in question was sold tell us when',
            message:
              'If you are not sure of the exact date give us your best guess and check the "Estimated" checkbox.',
            note: '',
          },
        },
        coOwner: {
          heading: {
            name: 'Provide full name of co-owner',
            address: 'Provide co-owner current address',
            countries: 'Provide co-owner’s country(ies) of citizenship',
            relationshipNature: 'Provide the nature of your relationship with the co-owner',
          },
          label: {
            address: 'This address is',
          },
          help: {
            countries: {
              title: 'List all citizenships this person has',
              message:
                'You can provide multiple citizenships in this question.  Selected values will appear below the country selection.',
              note: '',
            },
            relationshipNature: {
              title: 'Need help with the nature of this relationship?',
              message:
                'Let us know how you know this person and give us details of your relationship with them.',
              note: '',
            },
          },
        },
        coOwners: {
          heading: {
            hasCoOwners: 'Are/were/will there any co-owners of this foreign real estate?',
            hasCoOwnersAppend: 'Are there any additional co-owners for this foreign real estate?',
          },
        },
      },
    },
    support: {
      heading: {
        title: 'Have you EVER provided financial support for any foreign national?',
        name: 'Provide the name of the foreign national you support or have supported financially',
        address: 'Provide the address of the foreign national listed above',
        relationship:
          'Provide the nature of your relationship with the foreign national listed above',
        amount: 'Provide the amount (in U.S. dollars) of all financial support provided',
        frequency: 'Provide the frequency of your support',
        citizenship: "Provide this foreign national's country(ies) of citizenship",
      },
      label: {
        estimated: 'Estimated',
      },
      help: {
        branch: {
          title:
            'Need help determining if you have provided financial support to a foreign national?',
          message:
            'If you have provided any financial support to a foreign national then select "yes".',
          note: '',
        },
        address: {
          title: "Need help with the foreign national's address?",
          message: 'Provide the current address of the foreign national',
          note: '',
        },
        relationship: {
          title: 'Need help with the relation to the foreign national?',
          message: 'Provide the relationship to the foreign national',
          note: '',
        },
        amount: {
          title: 'Estimate the ammount if unsure',
          message:
            'If you are not sure of the exact amount give us your best guess and check the "Estimated" checkbox.',
          note: '',
        },
        frequency: {
          title: 'Need help with the frequency?',
          message: 'Provide the frequency of support',
          note: 'Note: Monthly, yearly, once, etc.',
        },
        citizenship: {
          title: 'List all citizenships this person has',
          message:
            'You can provide multiple citizenships in this question.  Selected values will appear below the country selection.',
          note: '',
        },
      },
      collection: {
        summary: {
          title: 'Summary of foreign financial support',
          item: 'Support',
          unknown: 'Provide details of foreign financial support below',
        },
        appendTitle: 'Have you additionally provided financial support for any foreign national?',
        append: 'Add another instance',
      },

    },
    benefit: {
      heading: {
        title:
          'As a U.S. citizen, have you, your spouse or legally recognized civil union/domestic partner, cohabitant, or dependent children received in the last seven (7) years, or are eligible to receive in the future, any educational, medical, retirement, social welfare, or other such benefit from a foreign country?',
        interestTypes: 'Specify',
        benefitType: 'Provide the type of benefit',
        benefitFrequency: 'Provide the frequency of the benefit',
        received: 'Provide the date the benefit was received',
        country: 'Provide the name of the country providing the benefit',
        value: 'Provide the total value (in U.S. dollars) of the benefit received.',
      },
      para: {
        checkAll: 'Check all that apply',
      },
      label: {
        otherBenefit: 'Provide explanation',
        otherBenefitType: 'Provide explanation',
        interestTypes: {
          yourself: 'Yourself',
          spouse: 'Spouse or legally recognized civil union/domestic partner',
          cohabitant: 'Cohabitant',
          dependentChildren: 'Dependent children',
        },
        benefitTypes: {
          educational: 'Educational',
          medical: 'Medical',
          retirement: 'Retirement',
          socialWelfare: 'Social Welfare',
          other: 'Other such benefit (Provide explanation)',
        },
        benefitFrequency: {
          oneTime: 'Onetime benefit',
          future: 'Future benefit',
          continuing: 'Continuing benefit',
          other: 'Other (Provide explanation)',
        },
      },
      collection: {
        summary: 'Provide your financial benefits here',
        description: 'Summary of financial benefits',
        appendTitle:
          'Do you, your spouse or legally recognized civil union/domestic partner, cohabitant, or dependent children receive any additional benefits from a foreign country?',
        appendLabel: 'Add another benefit',
        itemType: 'Benefit',
      },
      help: {
        benefit: {
          title: 'Need help with determining if you have received foreign benefits?',
          message:
            'As a U.S. citizen, have you, your spouse or legally recognized civil union/domestic partner, cohabitant, or dependent children received in the last seven (7) years, or are eligible to receive in the future, any educational, medical, retirement, social welfare, or other such benefit from a foreign country?',
          note: '',
        },
        interestType: {
          title: 'Need help with the interest type?',
          message: 'Provide the interest type',
          note: '',
        },
        benefitType: {
          title: 'Need help with the benefit type?',
          message: 'Provide the type of benefit',
          note: '',
        },
        benefitFrequency: {
          title: 'Need help with the benefit frequency?',
          message: 'Provide the frequency of the benefit',
          note: '',
        },
      },
      oneTime: {
        heading: {
          received: 'Provide the date the benefit was received',
          country: 'Provide the name of the country providing the benefit',
          value: 'Provide the total value (in U.S. dollars) of the benefit received.',
          reason: 'Provide the reason this benefit was received',
          obligated:
            'As a result of this benefit are you, your spouse or legally recognized civil union/domestic partner, your cohabitant, or dependent children obligated in any way to this foreign country?',
        },
        label: {
          obligatedExplanation: 'If yes provide explanation',
          valueEstimated: 'Estimated',
        },
        para: {
          obligated: 'If yes provide explanation',
        },
        help: {
          received: {
            title: 'Estimate the date if unsure',
            message:
              'If you are not sure of the exact date give us your best guess and check the "Estimated" checkbox.',
            note: '',
          },
          country: {
            title: 'Need help with the country?',
            message: 'Provide the name of the country providing the benefit',
            note: '',
          },
          value: {
            title: 'Need help with the value?',
            message: 'Provide the total value (in U.S. dollars) of the benefit received',
            note: '',
          },
          reason: {
            title: 'Need help with the reason?',
            message: 'Provide the reason this benefit was received',
            note: '',
          },
          obligated: {
            title: 'Need help with knowing if you are obligated?',
            message:
              'As a result of this benefit are you, your spouse or legally recognized civil union/domestic partner, your cohabitant, or dependent children obligated in any way to this foreign country',
            note: '',
          },
        },
      },
      future: {
        heading: {
          begin: 'Provide the date the benefit will begin',
          frequency: 'Provide the frequency the benefit will be received',
          country: 'Provide the name of the country providing the benefit',
          value: 'Provide the total value (in U.S. dollars) of the benefit to be received.',
          reason: 'Provide the reason this benefit will be received',
          obligated:
            'As a result of this benefit are you, your spouse or legally recognized civil union/domestic partner, your cohabitant, or dependent children obligated in any way to this foreign country?',
        },
        label: {
          obligatedExplanation: 'If yes provide explanation',
          valueEstimated: 'Estimated',
          frequency: {
            annually: 'Annually',
            quarterly: 'Quarterly',
            monthly: 'Monthly',
            weekly: 'Weekly',
            other: 'Other (Provide explanation)',
          },
        },
        para: {
          obligated: 'If yes provide explanation',
          frequencyOther: 'Provide explanation',
        },
        help: {
          begin: {
            title: 'Estimate the date if unsure',
            message:
              'If you are not sure of the exact date give us your best guess and check the "Estimated" checkbox.',
            note: '',
          },
          frequency: {
            title: 'Need help with the benefit frequency?',
            message: 'Provide the frequency the benefit will be received',
            note: '',
          },
          country: {
            title: 'Need help with the country?',
            message: 'Provide the name of the country providing the benefit',
            note: '',
          },
          value: {
            title: 'Need help with the value?',
            message: 'Provide the total value (in U.S. dollars) of the benefit to be received',
            note: '',
          },
          reason: {
            title: 'Need help with the reason?',
            message: 'Provide the reason this benefit will be received',
            note: '',
          },
          obligated: {
            title: 'Need help with knowing if you are obligated?',
            message:
              'As a result of this benefit are you, your spouse or legally recognized civil union/domestic partner, your cohabitant, or dependent children obligated in any way to this foreign country',
            note: '',
          },
        },
      },
      continuing: {
        heading: {
          began: 'Provide the date the benefit began',
          end: 'Provide the date the benefit is expected to end',
          frequency: 'Provide the frequency that this benefit is received',
          country: 'Provide the name of the country providing the benefit',
          value: 'Provide the total value (in U.S. dollars) of the benefit to be received',
          reason: 'Provide the reason this benefit will be received',
          obligated:
            'As a result of this benefit are you, your spouse or legally recognized civil union/domestic partner, your cohabitant, or dependent children obligated in any way to this foreign country?',
        },
        label: {
          obligatedExplanation: 'If yes provide explanation',
          valueEstimated: 'Estimated',
          frequency: {
            annually: 'Annually',
            quarterly: 'Quarterly',
            monthly: 'Monthly',
            weekly: 'Weekly',
            other: 'Other (Provide explanation)',
          },
        },
        para: {
          obligated: 'If yes provide explanation',
          frequencyOther: 'Provide explanation',
        },
        help: {
          began: {
            title: 'Estimate the date if unsure',
            message:
              'If you are not sure of the exact date give us your best guess and check the "Estimated" checkbox.',
            note: '',
          },
          end: {
            title: 'Estimate the date if unsure',
            message:
              'If you are not sure of the exact date give us your best guess and check the "Estimated" checkbox.',
            note: '',
          },
          frequency: {
            title: 'Need help with the benefit frequency?',
            message: 'Provide the frequency the benefit will be received',
            note: '',
          },
          country: {
            title: 'Need help with the country?',
            message: 'Provide the name of the country providing the benefit',
            note: '',
          },
          value: {
            title: 'Need help with the value?',
            message: 'Provide the total value (in U.S. dollars) of the benefit to be received',
            note: '',
          },
          reason: {
            title: 'Need help with the reason?',
            message: 'Provide the reason this benefit will be received',
            note: '',
          },
          obligated: {
            title: 'Need help with knowing if you are obligated?',
            message:
              'As a result of this benefit are you, your spouse or legally recognized civil union/domestic partner, your cohabitant, or dependent children obligated in any way to this foreign country',
            note: '',
          },
        },
      },
    },
  },
  contacts: {
    heading: {
      title:
        'Do you have, or have you had, close and/or continuing contact with a foreign national within the last seven (7) years with whom you, or your spouse, or legally recognized civil union/domestic partner, or cohabitant are bound by affection, influence, common interests, and/or obligation?',
      name: 'Provide the full name of the foreign national, if known',
      firstcontact: 'Provide the approximate date of first contact',
      lastcontact: 'Provide the approximate date of last contact',
      methods: 'Provide methods of contact',
      frequency: 'Provide approximate frequency of contact',
      relationship: 'Provide the nature of relationship',
      aliases: 'Has this foreign national used any other names and/or nicknames?',
      aliases2: 'Any additional other names and/or nicknames for this foreign national?',
      aliasname: 'Provide the other name or nickname',
      citizenship: "Provide this foreign national's country(ies) of citizenship",
      birthdate: "Provide this foreign national's date of birth",
      birthplace: "Provide this foreign national's place of birth",
      idkBirthplace: 'Provide explanation regarding unknown birthplace',
      address: "Provide this foreign national's current address",
      employer:
        "Provide the name of the foreign national's current employer, or provide the name of their most recent employer if not currently employed",
      employeraddress:
        "Provide the address of the foreign national's current employer, or provide the address of their most recent employer if not currently employed",
      hasaffiliations:
        'Is this foreign national affiliated with a foreign government, military, security, defense industry, or intelligence service?',
      affiliations:
        "Describe the contact's relationship with the foreign government, military, security, defense industry, or intelligence service",
      explanation: 'Explanation',
    },
    para: {
      includes:
        'Include associates as well as relatives, not previously listed in the relatives section.',
      definition:
        'A foreign national is defined as any person who is not a citizen or national of the U.S.',
      or: 'or',
      checkall: 'Check all that apply',
    },
    label: {
      idk: "I don't know",
      idkname: "I don't know their name",
      yes: 'Yes',
      no: 'No',
      inperson: 'In person',
      telephone: 'Telephone',
      electronic: 'Electronic (such as email, texting, chat rooms, etc)',
      written: 'Written correspondence',
      daily: 'Daily',
      weekly: 'Weekly',
      monthly: 'Monthly',
      quarterly: 'Quarterly',
      annually: 'Annually',
      professional: 'Professional or business',
      personal: 'Personal (such as family ties, friendship, affection, common interests, etc)',
      obligation: 'Obligation (provide explanation)',
      other: 'Other (provide explanation)',
      confirmation: 'Are you sure you would like to change your answer? This will remove any data currently entered.',
    },
    help: {
      branch: {
        title: 'Need help determining if you know any foreign nationals?',
        message: 'If you know anyone who is not a U.S. citizen or national then please click "yes"',
        note:
          'Note: A foreign national is defined as any person who is not a citizen or national of the U.S.',
      },
      firstcontact: {
        title: 'Let us know when you first met this person',
        message:
          'If you are not sure of the exact date give us your best guess and check the "Estimated" checkbox.',
        note: '',
      },
      lastcontact: {
        title: 'Tell us when you last had contact with this person',
        message:
          'Note: If you are not sure of the exact date give us your best guess and check the "Estimated" checkbox',
        note: '',
      },
      methods: {
        title: 'All of the ways you communicated with this person',
        message: 'Electronic includes social media.',
        note: '',
      },
      frequency: {
        title: 'Need help with the frequency of your communication?',
        message: 'Select the appropriate frequency of your correspondence',
        note: '',
      },
      relationship: {
        title: 'Need help with your relationship with this foreign national?',
        message: 'Check all the which apply to your relationship with the individual',
        note: '',
      },
      aliases: {
        title:
          'If this person has a nickname, a different maiden name, or used any other names answer "Yes"',
        message: 'If this person used multiple other names you will list each one separately.',
        note: '',
      },
      citizenship: {
        title: 'List all citizenships this person has',
        message:
          'You can provide multiple citizenships in this question.  Selected values will appear below the country selection.',
        note: '',
      },
      birthdate: {
        title: 'Need help with their date of birth?',
        message: 'Provide the approximate date of birth of the individual',
        note: 'Note: If you do not know then you may select "I don\'t know"',
      },
      birthplace: {
        title: 'Need help with their place of birth?',
        message: 'Provide the place of birth of the individual',
        note: 'Note: If you do not know then you may select "I don\'t know"',
      },
      address: {
        title: 'Need help with their current address?',
        message: 'Provide their most recent address',
        note: 'Note: If you do not know then you may select "I don\'t know"',
      },
      employer: {
        title: 'Need help with the employer?',
        message: 'Provide the name of their most recent employer',
        note: 'Note: If you do not know then you may select "I don\'t know"',
      },
      employeraddress: {
        title: 'Provide the address of their most recent employer',
        message: 'Note: If you do not know then you may select "I don\'t know".',
        note: '',
      },
      hasaffiliations: {
        title: 'Does this person have any affiliations?',
        message:
          'If the person has a relationship with a foreign government, military, security, defense industry, or intelligence service then select "yes"',
        note: '',
      },
      affiliations: {
        title: 'Need help describing their affiliations?',
        message: 'Describe the individuals relationship(s) with the foreign affiliations',
        note: '',
      },
    },
    collection: {
      summary: {
        title: 'Summary of foreign contacts',
        item: 'Foreign national',
        unknown: 'Provide the foreign national below',
      },
      appendTitle:
        'Do you have, or have you had, close and/or continuing contact with any additional foreign national within the last seven (7) years with whom you, or your spouse, or cohabitant are bound by affection, influence, common interests, and/or obligation?',
      appendMessage: [
        'Include associates as well as relatives, not previously listed in the relatives section.',
      ],
      append: 'Add another association',
    },
  },
  business: {
    advice: {
      heading: {
        title:
          'Have you in the last seven (7) years provided advice or support to any individual associated with a foreign business or other foreign organization that you have not previously listed as a former employer?',
        description: 'Provide a description of advice/support provided',
        name: 'Provide the name of the individual to whom advice or support was provided',
        organization:
          'Provide the name of the foreign organization or foreign business with whom the individual is associated',
        country: 'Provide the country of origin for the organization or business',
        dates: 'Provide the date(s) during which this advice or support was provided',
        compensation: 'Describe what compensation, if any, was provided for your service',
      },
      para: {
        branch:
          'Answer **"No"** if **all** your advice or support was authorized pursuant to official U.S. Government business.',
      },
      help: {
        description: {
          title: 'Need help with the description?',
          message: 'Provide how the support was provided',
          note: '',
        },
        organization: {
          title: 'Need help with the organization name?',
          message: 'Provide the name of the business',
          note: '',
        },
        country: {
          title: 'Need help with the country of origin?',
          message: 'Provide the country where the business is based',
          note: '',
        },
        dates: {
          title: 'Estimate the date if unsure',
          message:
            'If you are not sure of the exact dates give us your best guess and check the "Estimated" checkbox.',
          note: '',
        },
        compensation: {
          title: 'Need help with compensation?',
          message:
            'Any monetary, favor, trade, or other type of exchange for services render constitutes as compensation',
          note: '',
        },
      },
      collection: {
        summary: {
          title: 'Summary of foreign business advice',
          item: 'Advice',
          unknown: 'Provide details of foreign business advice below',
        },
        appendTitle:
          'Have you in the last seven (7) years provided advice or support to any other individual associated with a foreign business or other foreign organization that you have not previously listed as a former employer?',
        appendMessage: [
          'Answer **"No"** if all your advice or support was authorized pursuant to official U.S. Government business.',
        ],
        append: 'Add another instance of advice/support',
      },
    },
    family: {
      heading: {
        title:
          'Have you, your spouse or legally recognized civil union/domestic partner, cohabitant, or any member of your immediate family in the last seven (7) years been asked to provide advice or serve as a consultant, even informally, by any foreign government official or agency?',
        name: 'Provide the name of the government official',
        agency: 'Provide the name of the agency',
        country: 'Provide the country with which the government official or agency is affiliated',
        date: 'Provide the date of the request',
        circumstances: 'Provide the circumstances of request',
      },
      para: {
        branch: [
          'For this question, "Immediate Family" means your spouse or legally recognized civil union/domestic partner, parents, step-parents, siblings, half and step-siblings, children, step-children, and cohabitant.',
          'Answer **"No"** if all the advice or support was authorized pursuant to official U.S. Government business.',
        ],
      },
      help: {
        branch: {
          title: 'Need help determining if you have provided advice to foreign businesses?',
          message:
            'If you have provided any advice to a foreign individual or business then select "yes"',
          note:
            'Note: Answer **"no"** if **all** your advice or support was authorized pursuant to official U.S. Government business.',
        },
        agency: {
          title: 'Need help with the agency name?',
          message: 'Provide the agency name',
          note: '',
        },
        country: {
          title: 'Need help with the affiliated country?',
          message: 'Provide the country the request was affiliated with',
          note: '',
        },
        date: {
          title: 'Estimate the date if unsure',
          message:
            'If you are not sure of the exact date give us your best guess and check the "Estimated" checkbox.',
          note: '',
        },
        circumstances: {
          title: 'Need help with the circumstances?',
          message: 'Provide all circumstances of the request',
          note: '',
        },
      },
      collection: {
        summary: {
          title: 'Summary of family foreign business advice',
          item: 'Advice',
          unknown: 'Provide details of family foreign business advice below',
        },
        appendTitle:
          'Have you, your spouse or legally recognized civil union/domestic partner, cohabitant, or any member of your immediate family in the last seven (7) years been asked to provide advice or serve as a consultant, even informally, by any other foreign government official or agency?',
        appendMessage: [
          'Answer **"No"** if all the advice or support was authorized pursuant to official U.S. Government business.',
        ],
        append: 'Add another instance of advice/support',
      },
    },
    employment: {
      heading: {
        title:
          'Has any foreign national in the last seven (7) years offered you a job, asked you to work as a consultant, or consider employment with them?',
        name: 'Provide the name of the foreign national who made the offer',
        description: 'Provide a description of the position offered',
        date: 'Provide the date when this offer was extended',
        address: 'Provide the location where this occurred',
        accepted: 'Did you accept the offer?',
      },
      label: {
        explanation: 'Provide explanation',
        address: 'Did this occur in the United States?',
      },
      help: {
        branch: {
          title: 'Need help determining if you were offered a job?',
          message: 'If you were offered a foreign job select "yes"',
          note: '',
        },
        description: {
          title: 'Need help describing the offer?',
          message: 'Describe the position offered.',
          note: '',
        },
        date: {
          title: 'Estimate the date if unsure',
          message:
            'If you are not sure of the exact date give us your best guess and check the "Estimated" checkbox.',
          note: '',
        },
        address: {
          title: 'Need help with the location?',
          message: 'Provide the address of the location where the offer took place',
          note: '',
        },
        accepted: {
          title: 'Need help with describing the acceptance?',
          message: [
            'If you did not accept the offer please state this.',
            'If you did accept the offer please describe why it was accepted.',
          ],
          note: '',
        },
      },
      collection: {
        summary: {
          title: 'Summary of foreign business job offers',
          item: 'Offer',
          unknown: 'Provide details of foreign business job below',
        },
        appendTitle:
          'Has any additional foreign national, in the last seven (7) years, offered you a job, asked you to work a consultant, or consider employment with them?',
        append: 'Add another job offer',
      },
    },
    ventures: {
      heading: {
        title:
          'Have you in the last seven (7) years been involved in any other type of business venture with a foreign national not described above?',
        name: 'Provide the full name of this foreign national',
        address: 'Provide the full current address of this foreign national',
        citizenship: 'Provide the citizenship(s) of this foreign national',
        description: 'Provide a description of the business venture',
        relationship: 'Provide your relationship to this foreign national',
        dates: 'Provide the length of time you have been involved in the business venture',
        association: 'Provide the nature of the association with this business venture',
        position: 'Provide the position you held',
        service: 'Provide the service you provided',
        support: 'Provide the financial support involved',
        compensation: 'Provide a description of what compensation was provided for your service',
      },
      para: {
        branch: ['Own, co-own, serve as a business consultant, provide financial support, etc.'],
      },
      help: {
        branch: {
          title: 'Need help with the business venture?',
          message:
            'If you have, or are currently, associated with a foreign business venture select "yes"',
          note: '',
        },
        address: {
          title: "Need help with the foreign national's address?",
          message: 'Provide the current address of the foreign national',
          note: '',
        },
        citizenship: {
          title: 'List all citizenships this person has',
          message: 'You can provide multiple citizenships in this question.',
          note: '',
        },
        description: {
          title: 'Need help describing the business venture?',
          message: 'Provide an accurate description of the business venture',
          note: '',
        },
        relationship: {
          title: 'Need help with the relation to the foreign national?',
          message: 'Provide the relationship to the foreign national',
          note: '',
        },
        dates: {
          title: 'Estimate the date if unsure',
          message:
            'If you are not sure of the exact date give us your best guess and check the "Estimated" checkbox.',
          note: '',
        },
        association: {
          title: 'Need help with the association to the venture?',
          message: 'Provide a description of how you were associated to the business venture',
          note: '',
        },
        position: {
          title: 'Need help with the position?',
          message: 'Provide the position you held',
          note: '',
        },
        service: {
          title: 'Need help with the service provided?',
          message: 'Provide how the service you provided',
          note: '',
        },
        support: {
          title: 'Need help describing the financial support?',
          message: 'Provide any financial support that was provided',
          note: '',
        },
        compensation: {
          title: 'Need help describing the compensation?',
          message:
            'Any monetary, favor, trade, or other type of exchange for services render constitutes as compensation',
          note: '',
        },
      },
      collection: {
        summary: {
          title: 'Summary of foreign business ventures',
          item: 'Venture',
          unknown: 'Provide details of foreign business ventures below',
        },
        appendTitle:
          'Have you, in the last seven (7) years, been involved in any other type of business venture with a foreign national not described above?',
        appendMessage: [
          'Own, co-own, serve as a business consultant, provide financial support, etc.',
        ],
        append: 'Add another business venture',
      },
    },
    conferences: {
      heading: {
        title:
          'Have you in the last seven (7) years attended or participated in any conferences, trade shows, seminars, or meetings outside the U.S.?',
        description: 'Provide the name and description of the event',
        sponsor: 'Provide the name of sponsoring organization',
        city: 'Provide the city where the event was held',
        country: 'Provide the country where the event was held',
        dates: 'Provide the dates for the event',
        purpose: 'Provide the purpose of the event',
        contact:
          'Was there any subsequent contact with any foreign nationals as a result of the event?',
        contact2: 'Do you have another subsequent contact to report for this event?',
        explanation: 'Provide explanation',
      },
      para: {
        branch: [
          'Do not include those you attended or participated in on official business for the U.S. government.',
        ],
      },
      help: {
        branch: {
          title: 'Need help determining if you have been to a foreign conference?',
          message:
            'If you have to been to a conference not in the U.S. outside of official U.S. government business select "yes".',
          note: '',
        },
        description: {
          title: 'Need help with the description?',
          message: 'Provide the name of the conference as well as a general description.',
          note: '',
        },
        sponsor: {
          title: 'Need help with the sponsoring organization?',
          message: 'Provide the name(s) of the sponsoring organizations of the conference.',
          note: '',
        },
        city: {
          title: 'Need help with the city?',
          message: 'Provide the city the conference was located.',
          note: '',
        },
        country: {
          title: 'Need help with the country?',
          message: 'Provide the country the conference was located.',
          note: '',
        },
        dates: {
          title: 'Try looking up the event, this could help you find the dates',
          message:
            'If you can\'t find the exact date give us your best guess and check the "Estimated" checkbox.',
          note: '',
        },
        purpose: {
          title: 'Need help with the purpose of the conference?',
          message: 'Describe the purpose of the event.',
          note: '',
        },
        contact: {
          title: 'Contact after the event',
          message:
            'Did you have contact with any foreign nationals after this event? If so answer "Yes".',
          note: '',
        },
        explanation: {
          title: 'Need help with this explanation?',
          message: 'Tell us all the circumstances and/or outcome of the contact.',
          note: '',
        },
      },
      collection: {
        summary: {
          title: 'Summary of foreign business conferences',
          item: 'Event',
          unknown: 'Provide details of the event below',
        },
        appendTitle:
          'Have you in the last seven (7) years, attended or participated in any additional conferences, trade shows, seminars, or meetings outside the U.S.?',
        appendMessage: [
          'Do not include those you attended or participated in on official business for the U.S. government.',
        ],
        append: 'Add another event',
      },
    },
    contact: {
      heading: {
        title:
          'Have you or any member of your immediate family in the last seven (7) years had any contact with a foreign government, its establishment or its representatives, whether inside or outside the U.S.?',
        name: 'Provide the name of the individual involved in the contact',
        location: 'Provide the location of the contact',
        date: 'Provide the date of contact',
        governments: 'Provide the foreign government(s) involved',
        establishment:
          'Provide the type of establishment (such as embassy, consulate, agency, military service, intelligence or security service, etc.) involved',
        representatives: 'Provide the names of foreign representatives involved in contact',
        purpose: 'Provide the purpose/circumstances of contact',
        hassubsequent:
          'Was there any subsequent contact initiated by you, your immediate family member, or a representative of the foreign organization?',
        hassubsequent2: 'Do you have another subsequent contact to report for this event?',
        subsequent: 'Provide the purpose of the subsequent contact',
        recent: 'Provide the date of most recent contact',
        future: 'Provide plans for future contact',
      },
      para: {
        intro:
          'For this question, "Immediate Family" means your spouse, parents, step-parents, siblings, half and step-siblings, children, stepchildren, and cohabitant.',
        branch: [
          'Such as  embassy, consulate, agency, military service, intelligence or security service, etc.',
          'Answer **"No"** if the contact was for routine visa applications and border crossings related to either official U.S.  Government travel, foreign travel on a U.S. passport, or as a U.S. military service member in conjunction with a U.S. Government military duty.',
        ],
      },
      label: {
        location: 'Did this contact take place in the United States of America?',
      },
      help: {
        branch: {
          title: 'Need help determining if you have any foreign government contact?',
          message: 'If you have any foreign government contact then select "yes".',
          note: '',
        },
        location: {
          title: 'Need help with the location?',
          message: 'Provide the location of the contact.',
          note: '',
        },
        date: {
          title: 'Estimate the date if unsure',
          message:
            'If you are not sure of the exact date give us your best guess and check the "Estimated" checkbox.',
          note: '',
        },
        governments: {
          title: 'All governments involved in this contact',
          message: 'You can provide multiple governments in this question.',
          note: '',
        },
        establishment: {
          title: 'Need help with the establishment?',
          message: 'Provide the establishment.',
          note: '',
        },
        representatives: {
          title: 'Need help with the representatives?',
          message: 'Provide the representatives.',
          note: '',
        },
        purpose: {
          title: 'Need help with the purpose of contact?',
          message: 'Provide the purpose/circumstances of the contact.',
          note: '',
        },
        hassubsequent: {
          title: 'Any other contacts?',
          message: 'If there were any other contacts with the foreign organization select "Yes".',
          note: '',
        },
        subsequent: {
          title: 'Need help with the purpose of the subsequent contact?',
          message: 'Provide the purpose of the subsequent contact.',
          note: '',
        },
        recent: {
          title: 'Estimate the date if unsure',
          message:
            'If you are not sure of the exact date give us your best guess and check the "Estimated" checkbox.',
          note: '',
        },
        future: {
          title: 'Need help explaining future plans of contact?',
          message: 'Provide a description of any future plans of contact.',
          note: '',
        },
      },
      collection: {
        summary: {
          title: 'Summary of foreign government contacts',
          item: 'Contact',
          unknown: 'Provide details of contact below',
        },
        appendTitle:
          'Have you or any member of your immediate family in the last seven (7) years had any additional contact with a foreign government, its establishment or its representatives, whether inside or outside the U.S.?',
        appendMessage: [
          'Such as embassy, consulate, agency, military service, intelligence or security service, etc.',
          'Answer **"No"** if the contact was for routine visa applications and border crossings related to either official U.S. Government travel, foreign travel on a U.S. passport, or as a U.S. military service member in conjunction with a U.S. Government military duty.',
        ],
        append: 'Add another contact',
      },
    },
    sponsorship: {
      heading: {
        title:
          'Have you in the last seven (7) years sponsored any foreign national to come to the U.S. as a student, for work, or for permanent residence?',
        name: 'Provide the name of the sponsored foreign national',
        birthdate: 'Provide the date of birth for the sponsored foreign national',
        birthplace: 'Provide the place of birth for the sponsored foreign national',
        address: 'Provide the current street address of the sponsored foreign national',
        citizenship: 'Provide the country(ies) of citizenship for the sponsored foreign national',
        organization:
          'Provide the name of the organization through which sponsorship was arranged, if applicable',
        organizationaddress:
          'Provide the address of the organization through which the sponsorship was arranged, if applicable',
        dates: 'Provide the dates of stay in the U.S. for the sponsored foreign national',
        residence:
          'Provide the address of the sponsored foreign national while residing in the U.S.',
        stay: 'Provide the purpose of the stay in the U.S. for the sponsored foreign national',
        sponsorship: 'Provide the purpose of your sponsorship for the sponsored foreign national',
      },
      label: {
        idk: "I don't know",
        birthplace: 'Was this person born in the United States of America?',
      },
      para: {
        or: 'or',
      },
      help: {
        branch: {
          title: 'Foreign national defined:',
          message:
            'A foreign national is defined as any person who is not a citizen or national of the U.S.',
          note: '',
        },
        birthdate: {
          title: 'Estimate the date if unsure',
          message:
            'If you are not sure of the exact date give us your best guess and check the "Estimated" checkbox.',
          note: '',
        },
        birthplace: {
          title: 'Need help with the place of birth?',
          message: 'Provide the foreign nationals place of birth.',
          note: '',
        },
        address: {
          title: 'Acronyms:',
          message: 'APO - Army Post Office, FPO - Fleet Post Office.',
          note: '',
        },
        citizenship: {
          title: 'List all citizenships this person has',
          message:
            'You can provide multiple citizenships in this question.  Selected values will appear below the country selection.',
          note: '',
        },
        organization: {
          title: 'Need help with the organization?',
          message: 'Provide the organization name through which the sponsorship was arranged.',
          note: '',
        },
        organizationaddress: {
          title: "Try looking up the organization's name, this could help you find the address",
          message: 'If you can only find a phone number try calling and asking for the address.',
          note:
            'Acronyms: APO - Army Post Office, FPO - Fleet Post Office.',
        },
        dates: {
          title: 'Full date range the sponsored foreign national was in the U.S.',
          message:
            'If you are not sure of the exact dates give us your best guess and check the "Estimated" checkbox.',
          note: '',
        },
        residence: {
          title: 'Need help with the residence?',
          message: 'Provide the address of the sponsored foreign national.',
          note: '',
        },
        stay: {
          title: 'Need help with the purpose of the stay?',
          message: 'Provide the purpose for the stay within the U.S.',
          note: '',
        },
        sponsorship: {
          title: 'Need help with the purpose of the sponsorship?',
          message: 'Provide the purpose of the sponsorship.',
          note: '',
        },
      },
      collection: {
        summary: {
          title: 'Summary of foreign national sponsorship',
          item: 'Sponsorship',
          unknown: 'Provide details of sponsorship below',
        },
        appendTitle:
          'Have you in the last seven (7) years sponsored any additional foreign national to come to the U.S. as a student, for work, or for permanent residence?',
        appendMessage: [],
        append: 'Add another sponsorship',
      },
    },
    political: {
      heading: {
        title: 'Have you EVER held political office in a foreign country?',
        position: 'Provide the position held',
        dates: 'Provide the dates you held political office',
        country: 'Provide the name of the country involved',
        reason: 'Provide the reason(s) for these activities',
        eligibility:
          'Provide your current eligibility to hold political office in a foreign country',
      },
      label: {
        idk: "I don't know",
        birthplace: 'Was this person born in the United States of America?',
      },
      para: {
        or: 'or',
      },
      help: {
        branch: {
          title: 'Need help determining if you have any foreign government sponsorship?',
          message: 'If you have any foreign government sponsorship then select "yes".',
          note: '',
        },
        position: {
          title: 'Need help with the position?',
          message: 'Provide the position held.',
          note: '',
        },
        dates: {
          title: 'Full date range you held this political office',
          message:
            'If you are not sure of the exact dates give us your best guess and check the "Estimated" checkbox.',
          note: '',
        },
        country: {
          title: 'Need help with the country involved?',
          message: 'Provide the country involved.',
          note: '',
        },
        reason: {
          title: 'Need help with the reason?',
          message: 'Describe the reason for these activities.',
          note: '',
        },
        eligibility: {
          title: 'Need help with your current eligibility?',
          message: 'Provide your current eligibility for the political office.',
          note: '',
        },
      },
      collection: {
        summary: {
          title: 'Summary of foreign political office',
          item: 'Office',
          unknown: 'Provide details of political office below',
        },
        appendTitle: 'Have you EVER held any additional political office in a foreign country?',
        appendMessage: [],
        append: 'Add another political office',
      },
    },
    voting: {
      heading: {
        title: 'Have you EVER voted in the election of a foreign country?',
        date: 'Provide the date you voted in the foreign election',
        country: 'Provide the name of the country involved',
        reason: 'Provide the reason(s) for these activities',
        eligibility: 'Provide your current eligibility to vote in a foreign country',
      },
      help: {
        branch: {
          title: 'Need help determining if you have any foreign government sponsorship?',
          message: 'If you have any foreign government sponsorship then select "yes".',
          note: '',
        },
        date: {
          title: 'Estimate the date if unsure',
          message:
            'If you are not sure of the exact date give us your best guess and check the "Estimated" checkbox.',
          note: '',
        },
        country: {
          title: 'Need help with the country you voted in?',
          message: 'Provide the country name.',
          note: '',
        },
        reason: {
          title: 'Need help with the reason?',
          message: 'Describe the reason for these activities.',
          note: '',
        },
        eligibility: {
          title: 'Need help with your current eligibility?',
          message: 'Provide your current eligibility for voting.',
          note: '',
        },
      },
      collection: {
        summary: {
          title: 'Summary of foreign elections',
          item: 'Election',
          unknown: 'Provide details of election below',
        },
        appendTitle:
          'Do you have other instances of voting in the election of a foreign country to report?',
        appendMessage: [],
        append: 'Add another election',
      },
    },
  },
  travel: {
    heading: {
      outside: 'Have you traveled outside the U.S. in the last past seven (7) years?',
      official:
        'Has your travel in the last (7) years been solely for U.S. Government business/military overseas assignment on official government orders?',
      country: 'Provide the country visited',
      dates: 'Provide the dates of your travel to this country',
      days: 'Provide the total number of days involved in the visit(s)',
      purpose: 'Provide the purpose of the travel to this country',
      questioned:
        'While traveling to, or in this country, were you questioned, searched, or otherwise detained (other than for normal customs requirements) by the local customs or security service officials when entering or leaving this country?',
      encounter:
        'While traveling to or in this country, were you involved in any encounter with the police?',
      contacted:
        'While traveling to or in this country, were you contacted by, or in contact with any person known or suspected of being involved or associated with foreign intelligence, terrorist, security, or military organizations?',
      counter:
        'While traveling to, or in this country, were you involved in any counterintelligence or security issues not reported?',
      interest:
        'While traveling to or in this country, were you contacted by, or in contact with anyone exhibiting excessive knowledge of or undue interest in you or your job?',
      sensitive:
        'While traveling to or in this country, were you contacted by, or in contact with anyone attempting to obtain classified information or unclassified, sensitive information?',
      threatened:
        'While traveling to, or in this country, were you threatened, coerced, or pressured in any way to cooperate with a foreign government official or foreign intelligence or security service?',
      explanation: 'Provide explanation',
    },
    para: {
      personal:
        'I.e., no personal trips in conjunction with the official U.S. Government business.',
      checkall: 'Check all that apply',
      explanation: 'If yes provide explanation.',
      timeframe: [
        'Respond for the time frame of the last seven (7) years, beginning with the most recent and working backwards.',
        'Do not list trips that ONLY involved travel on official U.S. Government business on official government orders, but you must include any personal trips made in conjunction with the official U.S. Government travel.',
      ],
    },
    label: {
      one: '1-5',
      six: '6-10',
      eleven: '11-20',
      twentyone: '21-30',
      more: 'More than 30',
      many: 'Many short trips',
      business: 'Business/professional',
      volunteer: 'Volunteer activities',
      education: 'Education',
      tourism: 'Tourism',
      conference: 'Trade shows, conferences, and seminars',
      family: 'Visit family or friends',
      other: 'Other',
    },
    help: {
      outside: {
        title: 'Have you traveled outside the U.S.?',
        message: 'This includes many short trips to the same country.',
        note: '',
      },
      official: {
        title: 'Please enter each trip over the past seven (7) years.',
        message:
          'List the places you’ve travel to over the past seven (7) years, starting with your most recent trip and working backwards.',
        note:
          'Be sure to include any personal trips made in conjunction with the official federal government travel. Do not list trips that ONLY involved travel on official federal government business on official government orders.',
      },
      country: {
        title: 'Need help with the country?',
        message: 'Provide the name of the country you visited.',
        note: '',
      },
      dates: {
        title: 'Estimate the date if unsure',
        message:
          'If you are not sure of the exact dates give us your best guess and check the "Estimated" checkbox.',
        note: '',
      },
      days: {
        title: 'How long your travel was',
        message:
          'Many short trips means a gap between trips that is less than 6 months. For a travel gap longer than 6 months add another travel item.',
        note: '',
      },
      purpose: {
        title: 'Need help with the purpose?',
        message: 'Provide the purpose of the visit.',
        note: '',
      },
      questioned: {
        title: 'Were you questioned during the visit?',
        message: 'Provide an explanation for the questioning.',
        note: '',
      },
      encounter: {
        title: 'Did you encounter the police during the visit?',
        message: 'Provide an explanation for police involvement.',
        note: '',
      },
      contacted: {
        title: 'Were you contacted of any suspicious people?',
        message: 'Provide an explanation of the contact.',
        note: '',
      },
      counter: {
        title: 'Were you involved in any security issues?',
        message: 'Provide a description of your participation or experience.',
        note: '',
      },
      interest: {
        title: 'Did anyone seem to have a strong interest in your visit?',
        message: 'Provide a description detailing the circumstances.',
        note: '',
      },
      sensitive: {
        title: 'Did anyone attempt to obtain sensitive information from you?',
        message: 'Provide an accurate description.',
        note: '',
      },
      threatened: {
        title: 'Any coercion or pressure from the foreign government?',
        message: 'Provide a detailed account of the circumstances.',
        note: '',
      },
    },
    collection: {
      summary: {
        title: 'Summary of foreign travel',
        item: 'Travel',
        unknown: 'Provide details of your travel below',
      },
      appendTitle:
        'Do you have additional travel outside the U.S. in the last seven (7) years for other than solely U.S. Government business on official government orders?',
      appendMessage: [],
      append: 'Add another travel',
    },
  },

  travel_pvq: {
    heading: {
      intro: 'This section asks for information regarding foreign countries you have traveled to in the past 5 years and the purpose of those trips. (Only report information prior to your 18th birthday if necessary to report a minimum of 2 years of information.) We also want to know of any encounters you had with the foreign government, police, or any individuals showing an undue interest in you on these trips, as applicable. ',
      outside: 'Have you traveled to a foreign country in the past five years? (Do not list travel where you were on U.S. government or military orders. Do list personal trips taken in conjunction with work performed while on U.S. government or military orders.)',
      official:
        'Have you traveled to a foreign country in the past five years? (Do not list travel where you were on U.S. government or military orders. Do list personal trips taken in conjunction with work performed while on U.S. government or military orders.)',
      country: 'Which foreign country did you travel to?',
      dates: 'When did you travel to this country?',
      days: 'How long was this trip?',
      purpose: 'Why did you travel to this country? (Select all that apply.)',
      explanationOther: 'Please explain.',
      questioned:
        'While traveling to, from, or within this country, were you questioned, searched, or otherwise detained by customs, security officials, or any other entity? (This does not include those conducted as part of the normal customs\' process.)',
      encounter:
        'While traveling to, from, or within this country, did you have any encounters with the police? ',
      contacted:
        'While traveling to, from, or within this country, did you have contact with any person who you know or suspect is involved or associated with a foreign military, intelligence service, diplomatic service, security service, militia, other defense force,and government agency?',
      counter:
        'While traveling to, from, or within this country, did you have any incidents that were a potential security concern or considered suspicious activity, such as someone following you?',
      interest:
        'While traveling to, from, or within this country, did you have contact with anyone who exhibited excessive knowledge of, or had undue interest in, you or your work?',
      sensitive:
        'While traveling to or within this country, were you contacted by, or in contact with anyone attempting to obtain classified information or unclassified, sensitive information?',
      threatened:
        'While traveling to, from, or within this country, were you threatened, coerced, or pressured in any way to cooperate with a foreign government official (such as from a foreign military, intelligence service, diplomatic service, security service, a militia, and other defense forces)?',
      explanation: 'Please explain',
      intro_1: 'Foreign means non-U.S. -- that is, outside of the 50 U.S. states, District of Columbia, and U.S. territories.',
      intro_2: 'List personal trips taken in conjunction with duty performed while on U.S. government or military orders. Examples of personal trips include vacations, side trips, or other unofficial travel made for personal reasons.',
      intro_3: 'Each entry into and out of a country is a new trip (this includes layovers).',
      intro_4: 'Do not list travel where you were on official U.S. government or military orders.',
      intro_5: 'Do not list foreign travel you previously listed on this form.',

    },
    para: {
      personal:
        'I.e., no personal trips in conjunction with the official U.S. Government business.',
      checkall: 'Check all that apply',
      explanation: 'If yes provide explanation.',
      timeframe: [
        'Respond for the time frame of the last seven (7) years, beginning with the most recent and working backwards.',
        'Do not list trips that ONLY involved travel on official U.S. Government business on official government orders, but you must include any personal trips made in conjunction with the official U.S. Government travel.',
      ],
    },
    label: {
      one: 'Less than 24 hours',
      six: '1-7 days',
      eleven: '8-14 days',
      twentyone: '15-30 days',
      more: 'Over 30 days',
      many: 'Many short trips',
      business: 'Business or professional conference',
      volunteer: 'Volunteer activities',
      education: 'Education',
      tourism: 'Tourism',
      conference: 'Trade show, conference, or seminar',
      family: 'Visit with family or friends',
      other: 'Other',
    },
    help: {
      outside: {
        title: 'Have you traveled outside the U.S.?',
        message: 'This includes many short trips to the same country.',
        note: '',
      },
      official: {
        title: 'Please enter each trip over the past seven (7) years.',
        message:
          'List the places you’ve travel to over the past seven (7) years, starting with your most recent trip and working backwards.',
        note:
          'Be sure to include any personal trips made in conjunction with the official federal government travel. Do not list trips that ONLY involved travel on official federal government business on official government orders.',
      },
      country: {
        title: 'Need help with the country?',
        message: 'Provide the name of the country you visited.',
        note: '',
      },
      dates: {
        title: 'Estimate the date if unsure',
        message:
          'If you are not sure of the exact dates give us your best guess and check the "Estimated" checkbox.',
        note: '',
      },
      days: {
        title: 'How long your travel was',
        message:
          'Many short trips means a gap between trips that is less than 6 months. For a travel gap longer than 6 months add another travel item.',
        note: '',
      },
      purpose: {
        title: 'Need help with the purpose?',
        message: 'Provide the purpose of the visit.',
        note: '',
      },
      questioned: {
        title: 'Were you questioned during the visit?',
        message: 'Provide an explanation for the questioning.',
        note: '',
      },
      encounter: {
        title: 'Did you encounter the police during the visit?',
        message: 'Provide an explanation for police involvement.',
        note: '',
      },
      contacted: {
        title: 'Were you contacted of any suspicious people?',
        message: 'Provide an explanation of the contact.',
        note: '',
      },
      counter: {
        title: 'Were you involved in any security issues?',
        message: 'Provide a description of your participation or experience.',
        note: '',
      },
      interest: {
        title: 'Did anyone seem to have a strong interest in your visit?',
        message: 'Provide a description detailing the circumstances.',
        note: '',
      },
      sensitive: {
        title: 'Did anyone attempt to obtain sensitive information from you?',
        message: 'Provide an accurate description.',
        note: '',
      },
      threatened: {
        title: 'Any coercion or pressure from the foreign government?',
        message: 'Provide a detailed account of the circumstances.',
        note: '',
      },
    },
    collection: {
      summary: {
        title: 'Summary of foreign travel',
        item: 'Travel',
        unknown: 'Provide details of your travel below',
      },
      appendTitle:
        'Do you have another foreign country that you traveled to in the past five years to report? (Do not list travel where you were on U.S. government or military orders. Do list personal trips taken in conjunction with work performed while on U.S. government or military orders.) ',
      appendMessage: [],
      append: 'Add another travel',
    },
  },
};
